(function (lib, img, cjs, ss, an) {

var p; // shortcut to reference prototypes
lib.ssMetadata = [
		{name:"MWiguana_atlas_", frames: [[192,520,96,70],[290,544,84,54],[422,500,84,54],[192,592,72,32],[446,280,40,58],[454,556,40,58],[446,78,48,68],[376,556,76,54],[312,438,108,104],[266,600,46,28],[422,438,82,60],[0,388,82,44],[446,148,44,64],[446,214,44,64],[96,520,94,106],[0,520,94,106],[178,356,310,80],[0,438,310,80],[210,178,234,176],[210,0,234,176],[446,0,52,76],[84,388,78,46],[0,0,208,208],[0,210,176,176]]}
];


// symbols:



(lib.IguanaBackFoot = function() {
	this.spriteSheet = ss["MWiguana_atlas_"];
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib.IguanaBackLegLower0001 = function() {
	this.spriteSheet = ss["MWiguana_atlas_"];
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib.IguanaBackLegLower0002 = function() {
	this.spriteSheet = ss["MWiguana_atlas_"];
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib.IguanaFrontBackFoot = function() {
	this.spriteSheet = ss["MWiguana_atlas_"];
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib.IguanaFrontBackLowerLeg0001 = function() {
	this.spriteSheet = ss["MWiguana_atlas_"];
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib.IguanaFrontBackLowerLeg0002 = function() {
	this.spriteSheet = ss["MWiguana_atlas_"];
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib.IguanaFrontBackUpperLeg = function() {
	this.spriteSheet = ss["MWiguana_atlas_"];
	this.gotoAndStop(6);
}).prototype = p = new cjs.Sprite();



(lib.IguanaHand = function() {
	this.spriteSheet = ss["MWiguana_atlas_"];
	this.gotoAndStop(7);
}).prototype = p = new cjs.Sprite();



(lib.IguanaHead = function() {
	this.spriteSheet = ss["MWiguana_atlas_"];
	this.gotoAndStop(8);
}).prototype = p = new cjs.Sprite();



(lib.IguanaHindBackFoot = function() {
	this.spriteSheet = ss["MWiguana_atlas_"];
	this.gotoAndStop(9);
}).prototype = p = new cjs.Sprite();



(lib.IguanaHindBackLowerLeg = function() {
	this.spriteSheet = ss["MWiguana_atlas_"];
	this.gotoAndStop(10);
}).prototype = p = new cjs.Sprite();



(lib.IguanaHindBackUpperLeg = function() {
	this.spriteSheet = ss["MWiguana_atlas_"];
	this.gotoAndStop(11);
}).prototype = p = new cjs.Sprite();



(lib.IguanaLowerarm0001 = function() {
	this.spriteSheet = ss["MWiguana_atlas_"];
	this.gotoAndStop(12);
}).prototype = p = new cjs.Sprite();



(lib.IguanaLowerarm0002 = function() {
	this.spriteSheet = ss["MWiguana_atlas_"];
	this.gotoAndStop(13);
}).prototype = p = new cjs.Sprite();



(lib.IguanaNeck0001 = function() {
	this.spriteSheet = ss["MWiguana_atlas_"];
	this.gotoAndStop(14);
}).prototype = p = new cjs.Sprite();



(lib.IguanaNeck0002 = function() {
	this.spriteSheet = ss["MWiguana_atlas_"];
	this.gotoAndStop(15);
}).prototype = p = new cjs.Sprite();



(lib.IguanaTail0001 = function() {
	this.spriteSheet = ss["MWiguana_atlas_"];
	this.gotoAndStop(16);
}).prototype = p = new cjs.Sprite();



(lib.IguanaTail0002 = function() {
	this.spriteSheet = ss["MWiguana_atlas_"];
	this.gotoAndStop(17);
}).prototype = p = new cjs.Sprite();



(lib.IguanaTorso0001 = function() {
	this.spriteSheet = ss["MWiguana_atlas_"];
	this.gotoAndStop(18);
}).prototype = p = new cjs.Sprite();



(lib.IguanaTorso0002 = function() {
	this.spriteSheet = ss["MWiguana_atlas_"];
	this.gotoAndStop(19);
}).prototype = p = new cjs.Sprite();



(lib.IguanaUpperArm = function() {
	this.spriteSheet = ss["MWiguana_atlas_"];
	this.gotoAndStop(20);
}).prototype = p = new cjs.Sprite();



(lib.IguanaUpperLeg = function() {
	this.spriteSheet = ss["MWiguana_atlas_"];
	this.gotoAndStop(21);
}).prototype = p = new cjs.Sprite();



(lib.M_Wash_Bubble = function() {
	this.spriteSheet = ss["MWiguana_atlas_"];
	this.gotoAndStop(22);
}).prototype = p = new cjs.Sprite();



(lib.M_Wash_Bubble_pop = function() {
	this.spriteSheet = ss["MWiguana_atlas_"];
	this.gotoAndStop(23);
}).prototype = p = new cjs.Sprite();
// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.Wet_drop = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#91D6F7").s().p("AgeBSQgPgSgCgjQgCgiAkheQA2BhAFAgQAFAkgOARQgOARgUAAQgTAAgOgSg");
	this.shape.setTransform(4.8,10);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,9.6,20);


(lib.SmallStar = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFF99").s().p("Ag1BSQgGgDAFgaIAHgaIgVgVQgVgUADgFQACgFAbgFIAbgFIAMgYQAOgYAEAAQAHAAAYAyIAbADQAbAEACAGQAEAJgtAlQAPAzgHAEQgHAEgvgaQgkAXgNAAIgEgBg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-8.7,-8.3,17.6,16.7);


(lib.LargeStar = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFF99").s().p("AhGBuQgJgFAHgjIAJgiIgcgbQgbgcADgGQADgHAkgHIAjgGIARggQATghAFABQAKgBAgBDIAjAEQAkAGADAIQAFAMg7AxQAUBEgKAGQgKAFg+gjQgwAegRAAIgFAAg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-11.6,-11,23.4,22.1);


(lib.sparkle = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AgZAGQAYgRABg2QACA2AYANQgWAVgDArQgIgxgSgLg");
	this.shape.setTransform(-0.1,1);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFFF").s().p("AggAkQgLgQgMgHQANgKAKgOQAdgsADhXQAEBYAeAoQAJAMAMAHIABAAQgNALgJAQQgaApgFBFIAAABQgNhJgWgig");
	this.shape_1.setTransform(-0.1,1);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FFFFFF").s().p("AgyA5QgQgZgTgMQAUgPAPgWQAthEAFiHQAGCJAvA9QAOAUASAKQgSASgOAYQgpBAgHBrQgVhwgig0gAgZAGQASALAIAxQAEgsAVgUQgYgNgCg3QgBA3gYARg");
	this.shape_2.setTransform(-0.1,1);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#FFFFFF").s().p("Ag0BYQA1AmAzgmQgnBAgHBqQgWh2gkg0gAhxAKQATgNAPgYQgVAlAVAlQgQgZgSgMgABRgfQAOATATALQgTARgOAYQAUglgUgigAgrhAQAnhDAEh9QAHCDAqA9QgugpguApg");
	this.shape_3.setTransform(-0.2,2);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#FFFFFF").s().p("AgMC8QAQAaAOgaQgIAlgEAtQgHgugLgkgAh7ALIASgPQgMARALAMQgIgJgJgFgABvgJIANAJIgNAMQAIgMgIgJgAgJisQAIgrABg2QADA3AJAqQgLgOgKAOg");
	this.shape_4.setTransform(-0.3,1.9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.shape_1}]},1).to({state:[{t:this.shape_2}]},1).to({state:[{t:this.shape_3}]},1).to({state:[{t:this.shape_4}]},1).to({state:[]},1).wait(45));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-2.7,-5.7,5.2,13.3);


(lib.M_Wash_Bubble_pop_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.M_Wash_Bubble_pop();
	this.instance.parent = this;
	this.instance.setTransform(-9,-9,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFFFF").ss(1.9,1,1).p("AAtACIARAAAACg9IAAAUAAgghIAJgMAg9AAIAYgBAgmgrIANAPAgrArIALgNAgEAwIAAAOAAdAoIAKAN");
	this.shape.setTransform(11.2,10.6);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.M_Wash_Bubble_pop_1, new cjs.Rectangle(-9,-9,44,44), null);


(lib.M_Wash_Bubble_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.M_Wash_Bubble();
	this.instance.parent = this;
	this.instance.setTransform(-13,-13,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.M_Wash_Bubble_1, new cjs.Rectangle(-13,-13,52,52), null);


(lib.invisiblebox = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(255,255,255,0)").s().p("AhwDIIhZgEIAEmHIBOgEIDvAAIBSABIgCGKIhGAEg");
	this.shape.setTransform(-0.3,0);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.invisiblebox, new cjs.Rectangle(-20.5,-20,40.4,40), null);


(lib.IguanaUpperLeg_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 3
	this.instance = new lib.IguanaUpperLeg();
	this.instance.parent = this;
	this.instance.setTransform(-2,-2,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.IguanaUpperLeg_1, new cjs.Rectangle(-2,-2,39,23), null);


(lib.IguanaUpperArm_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 3
	this.instance = new lib.IguanaUpperArm();
	this.instance.parent = this;
	this.instance.setTransform(-2,-2,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.IguanaUpperArm_1, new cjs.Rectangle(-2,-2,26,38), null);


(lib.IguanaLowerarm = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{dirty:0,dirty_stop:1,clean:2,clean_loop:3,glow:4,glow_loop:5,wash:6,wash_stop:209,glowclean:210,glowclean_loop:211,"final":212,final_loop:213});

	// Layer 4
	this.instance = new lib.IguanaLowerarm0001();
	this.instance.parent = this;
	this.instance.setTransform(-1.9,-3.2,0.5,0.5);

	this.instance_1 = new lib.IguanaLowerarm0002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-1.9,-3.2,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance}]},2).to({state:[{t:this.instance_1}]},2).to({state:[]},208).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-1.9,-3.2,22,32);


(lib.IguanaHindBackUpperLeg_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.IguanaHindBackUpperLeg();
	this.instance.parent = this;
	this.instance.setTransform(-1.9,-2.1,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.IguanaHindBackUpperLeg_1, new cjs.Rectangle(-1.9,-2.1,41,22), null);


(lib.IguanaHindBackLowerLeg_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.IguanaHindBackLowerLeg();
	this.instance.parent = this;
	this.instance.setTransform(-2,-2.1,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.IguanaHindBackLowerLeg_1, new cjs.Rectangle(-2,-2.1,41,30), null);


(lib.IguanaHindBackFoot_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.IguanaHindBackFoot();
	this.instance.parent = this;
	this.instance.setTransform(-1.8,-2.1,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.IguanaHindBackFoot_1, new cjs.Rectangle(-1.8,-2.1,23,14), null);


(lib.IguanaHand_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 3
	this.instance = new lib.IguanaHand();
	this.instance.parent = this;
	this.instance.setTransform(-2.1,-2.1,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.IguanaHand_1, new cjs.Rectangle(-2.1,-2.1,38,27), null);


(lib.IguanaFrontBackUpperLeg_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.IguanaFrontBackUpperLeg();
	this.instance.parent = this;
	this.instance.setTransform(-1.9,-2,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.IguanaFrontBackUpperLeg_1, new cjs.Rectangle(-1.9,-2,24,34), null);


(lib.IguanaFrontBackLowerLeg = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":209,"glowclean":210,"glowclean_loop":211,"final":212,"final_loop":213});

	// Layer 2
	this.instance = new lib.IguanaFrontBackLowerLeg0001();
	this.instance.parent = this;
	this.instance.setTransform(-1.9,-2.6,0.5,0.5);

	this.instance_1 = new lib.IguanaFrontBackLowerLeg0002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-1.9,-2.6,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance}]},2).to({state:[{t:this.instance_1}]},2).to({state:[]},208).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-1.9,-7.8,20,34.3);


(lib.IguanaFrontBackFoot_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.IguanaFrontBackFoot();
	this.instance.parent = this;
	this.instance.setTransform(-1.8,-2,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.IguanaFrontBackFoot_1, new cjs.Rectangle(-1.8,-2,36,16), null);


(lib.IguanaBackFoot_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 3
	this.instance = new lib.IguanaBackFoot();
	this.instance.parent = this;
	this.instance.setTransform(-1.9,-2.5,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.IguanaBackFoot_1, new cjs.Rectangle(-1.9,-2.5,48,35), null);


(lib.iguana_tailGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFF00").ss(3,1,1).p("AGfBDQAFAHACABIABABIAAAAQAAAAABAAQABAAADgDQADgCAAAAQACAAACAEQACADABACIABAAQACAAABgBQADAAADgCQAAABABABIAAABQACADABABQABAAABgBQAAAAABAAQAEgCABAAIAAAFQAEACADABQAEADgEABQgRAIgtAAIl/gTQhPgDiKgMQhzgJgogGQg/gKgagQQgdgSAAggQAAgUADgFQADgHAUgVIAJgJQALgGAIgDQAFgBAIADQABgBACgBQAEgDADgBQAMgEAFAWQAFgDAIgBQAIgCADACQAEAGADAGQABACABADIABAAIALgEQAGgDADAAQAEAAAFAJQAGAJABAAQAGAAAFgFQAGgFAFAAQAEAGADAKQAEABAHgEQAHgEACAAQAFAAAEAIQAFAIABAAQADAAAGgDQAFgFADAAQACAAAGAIQAGAHABAAQACAAAGgDQAGgEAEAAQAEAAAHAIQAIAIABABQADgFACgCQAEgEAGAAQAFAAAEAIQAEAIACAAQASgJADAAQAGAAAFAHQAGAGABAAQACAAAEgEQAEgEAEAAQAEAAAFAHQAGAGADAAQALgJAEAAQAFAAAFAIQAEAJADAAQABAAAHgFQAHgFACAAQAEAAADAGQAEAGACAAQAJgHAHAAQADAAAGAGQAFAFACAAQACAAAFgDQAFgEADAAQABAAAHAEQAHAFAAAAQACAAADgEQAEgCADAAQACAAAHAFQAHAFACAAQABAAAFgDQAEgDADAAQACAAAEAFQADAFADAAQABAAACgDQADgCAEAAQAFAAAFAFQAFAFACAAQACAAAFgEQAGgEADABQADAAAGAGQAGAGAEADIAZgIQAGAIACADQACACACADQACACAEgGQAFgGADAAQAEAAAEAGQAEAGADAFQAEAAADABQABgBABAAIAAgBQAFgFADgDQADgDAEAEQAFAOABgCQAAgCAFgFQAFgFADADQACAEACAJIABAAQALgIACgBQABgBABAFQABAEACAEQALgHACgBQADgCAAAEIADAKIABAAQAGgGADgDQADgEABABQABABADAGQADAFACAEIAGgEQABAAABgBQAFgCAAgBQAGALACAAIABABQAAgBAAAAQADgBAGgEQABAAAFAFQADADABABQABAAAAABQAAgBAAAAQAAABABAAIAJgEQAAAAACADIABAAQACAEACAAIABABQAAAAAAgBQACAAADgCg");
	this.shape.setTransform(46.9,10.1);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.iguana_tailGlow, new cjs.Rectangle(-1.5,-1.5,96.8,23.2), null);


(lib.iguana_neckGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFF00").ss(3,1,1).p("AALhOQgCACgCAAQABgFAAgDQAAgGgIACQACgHAAgDQAAgGgRAAQACgIgCgEQgCgGgQABQAAgNgFgDQgEgDgFAGQgDABAAABQgFgDgEgDIgDgBQAnA0gMApQgEANgHAoQgKAlgVAPQgcATAIAdQAKAhA+AAQAsAAAYgWQANgMATgPQASgPAEgLQADgMgBgHQgBgHgUgZQABgBAAgBIAAgEQAAgGgDgBQgEgBgFABIADgVQgCgBgEABQgFAAgDACQAAgGAAgEQgBgIgFAAQgDAAgBABQgCAEAAAAQgBgGgBgEQgBgHgKADIgBgOQgDgCgGABQABgFAAgFQgBgJgGAAQgBAAgDABg");
	this.shape.setTransform(10,14);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.iguana_neckGlow, new cjs.Rectangle(-1.5,-1.5,22.9,31), null);


(lib.iguana_legGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 3
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFF00").ss(3,1,1).p("ABKAKQgNAFgGAGQgPAHAAATQAAAaArATQATAJAyAdQgCACgCACQAWABAUADQAgAAAggBQgEghglgcQAVgNAFgHQADgEABgLQABgJgBgGQgBgKgRgLQgMgHgMAAQgDgBgVAAIgSAAQgMAAgCAAQgsADgbAKgAiKANQgEgJgFgLQgTgtgDgSQgBgFABgVQABgRgFgKQgEgLgCgCQgGgJgIgFQgLgFgKgBQgKgBgKAIQgKAIgIAXQgHAXAwA2QgNAAAJAgQAAABABACIAAAAQgCADgCADIgBAJQAAAAAAABQAAAHAEAJQAAACgBADQgBAKgBAEIgGAbQgCAMgCAHIgCABQAJASASABQABAAABAAQgDAIgEAGQAEAAAGAAQALABAGADQAHAEADAJQACAFAEAKQAFgBAFgJQAKgQABghQACgOAAgJQAKgDAFgOQAEgTAAAAQAAgOgLgJQgCgCgCgBIAAAAIAAABQgBAAAAAAg");
	this.shape.setTransform(-3.9,-1.8);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.iguana_legGlow, new cjs.Rectangle(-30.7,-19,53.7,34.4), null);


(lib.iguana_backGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFF00").ss(3,1,1).p("AD7ByQAAAAgBgDQgBgCAAgCIgBgDQgDgFgDgEQgDgGgJAEQgIAFgEgKQgCgKgDAAQAAAAgBAAQgDAAgFAEQgGAFgCgMQgCgMgKAIQgKAIgJgWIgFACQgFABgDACQgEACgCgFIAAgDIAAgBQgBgJgEgBQgCgBgFACIgEACQgIAFgCgIIAAAAIgBgDQgBgEgCgBQgDgBgNAEIAAAAQACgfgaANQgCgMgDgGQgBgEgFABQgEgBgIADIAAgDQgBgDAAgDQgBgHgFgDIgBgBIgBABQgCAAAAgBIgJABQAAABgBAAQgCABgDAAIgDAAQAAgBABgCQABgFAAgFIAAgEQgBAAAAgBIAAgBQAAgCgJACQgHAAgEACIgBgGQgBgIgBgCQgEgHgVAHQAAgDgFgIQgIgXgXAUQgCgGgCgFQgDgIgIABQgIABgEAFQgBgHgDgGQgFgJgIABQgFAAgJAGQgDgCgCgGQgBgFAAgCIAAgBQAAgBgYAFIgEgLQgEgNgGAAIgCABQgFAAgFACQgGADgBgDQgCgHgGgCQgLAAgDACQgCABgBgBQgBgBgBgCQgDgFgFAAIAAAAQgFAAgIADQgBAAgCAAQgCABgBABQgBAAgBABQgDAAgEABIgHAFQgDBgA0A7QA2A+ByAaQB0AbB1gMIAvgP");
	this.shape.setTransform(25.1,13.7);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.iguana_backGlow, new cjs.Rectangle(-1.5,-1.5,53.3,30.5), null);


(lib.blueglowtail = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(3,1,1).p("AGfBDQAFAHACABIABABIAAAAQAAAAABAAQABAAADgDQADgCAAAAQACAAACAEQACADABACIABAAQACAAABgBQADAAADgCQAAABABABIAAABQACADABABQABAAABgBQAAAAABAAQAEgCABAAIAAAFQAEACADABQAEADgEABQgRAIgtAAIl/gTQhPgDiKgMQhzgJgogGQg/gKgagQQgdgSAAggQAAgUADgFQADgHAUgVIAJgJQALgGAIgDQAFgBAIADQABgBACgBQAEgDADgBQAMgEAFAWQAFgDAIgBQAIgCADACQAEAGADAGQABACABADIABAAIALgEQAGgDADAAQAEAAAFAJQAGAJABAAQAGAAAFgFQAGgFAFAAQAEAGADAKQAEABAHgEQAHgEACAAQAFAAAEAIQAFAIABAAQADAAAGgDQAFgFADAAQACAAAGAIQAGAHABAAQACAAAGgDQAGgEAEAAQAEAAAHAIQAIAIABABQADgFACgCQAEgEAGAAQAFAAAEAIQAEAIACAAQASgJADAAQAGAAAFAHQAGAGABAAQACAAAEgEQAEgEAEAAQAEAAAFAHQAGAGADAAQALgJAEAAQAFAAAFAIQAEAJADAAQABAAAHgFQAHgFACAAQAEAAADAGQAEAGACAAQAJgHAHAAQADAAAGAGQAFAFACAAQACAAAFgDQAFgEADAAQABAAAHAEQAHAFAAAAQACAAADgEQAEgCADAAQACAAAHAFQAHAFACAAQABAAAFgDQAEgDADAAQACAAAEAFQADAFADAAQABAAACgDQADgCAEAAQAFAAAFAFQAFAFACAAQACAAAFgEQAGgEADABQADAAAGAGQAGAGAEADIAZgIQAGAIACADQACACACADQACACAEgGQAFgGADAAQAEAAAEAGQAEAGADAFQAEAAADABQABgBABAAIAAgBQAFgFADgDQADgDAEAEQAFAOABgCQAAgCAFgFQAFgFADADQACAEACAJIABAAQALgIACgBQABgBABAFQABAEACAEQALgHACgBQADgCAAAEIADAKIABAAQAGgGADgDQADgEABABQABABADAGQADAFACAEIAGgEQABAAABgBQAFgCAAgBQAGALACAAIABABQAAgBAAAAQADgBAGgEQABAAAFAFQADADABABQABAAAAABQAAgBAAAAQAAABABAAIAJgEQAAAAACADIABAAQACAEACAAIABABQAAAAAAgBQACAAADgCg");
	this.shape.setTransform(46.9,10.1);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.blueglowtail, new cjs.Rectangle(-1.5,-1.5,96.8,23.2), null);


(lib.blueglowneck = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(3,1,1).p("AALhOQgCACgCAAQABgFAAgDQAAgGgIACQACgHAAgDQAAgGgRAAQACgIgCgEQgCgGgQABQAAgNgFgDQgEgDgFAGQgDABAAABQgFgDgEgDIgDgBQAnA0gMApQgEANgHAoQgKAlgVAPQgcATAIAdQAKAhA+AAQAsAAAYgWQANgMATgPQASgPAEgLQADgMgBgHQgBgHgUgZQABgBAAgBIAAgEQAAgGgDgBQgEgBgFABIADgVQgCgBgEABQgFAAgDACQAAgGAAgEQgBgIgFAAQgDAAgBABQgCAEAAAAQgBgGgBgEQgBgHgKADIgBgOQgDgCgGABQABgFAAgFQgBgJgGAAQgBAAgDABg");
	this.shape.setTransform(10,14);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.blueglowneck, new cjs.Rectangle(-1.5,-1.5,22.9,31), null);


(lib.blueglowlegs = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 3
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(3,1,1).p("ABKAKQgNAFgGAGQgPAHAAATQAAAaArATQATAJAyAdQgCACgCACQAWABAUADQAgAAAggBQgEghglgcQAVgNAFgHQADgEABgLQABgJgBgGQgBgKgRgLQgMgHgMAAQgDgBgVAAIgSAAQgMAAgCAAQgsADgbAKgAiKANQgEgJgFgLQgTgtgDgSQgBgFABgVQABgRgFgKQgEgLgCgCQgGgJgIgFQgLgFgKgBQgKgBgKAIQgKAIgIAXQgHAXAwA2QgNAAAJAgQAAABABACIAAAAQgCADgCADIgBAJQAAAAAAABQAAAHAEAJQAAACgBADQgBAKgBAEIgGAbQgCAMgCAHIgCABQAJASASABQABAAABAAQgDAIgEAGQAEAAAGAAQALABAGADQAHAEADAJQACAFAEAKQAFgBAFgJQAKgQABghQACgOAAgJQAKgDAFgOQAEgTAAAAQAAgOgLgJQgCgCgCgBIAAAAIAAABQgBAAAAAAg");
	this.shape.setTransform(-3.9,-1.8);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.blueglowlegs, new cjs.Rectangle(-30.7,-19,53.7,34.4), null);


(lib.blueglowback = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(3,1,1).p("AD7ByQAAAAgBgDQgBgCAAgCIgBgDQgDgFgDgEQgDgGgJAEQgIAFgEgKQgCgKgDAAQAAAAgBAAQgDAAgFAEQgGAFgCgMQgCgMgKAIQgKAIgJgWIgFACQgFABgDACQgEACgCgFIAAgDIAAgBQgBgJgEgBQgCgBgFACIgEACQgIAFgCgIIAAAAIgBgDQgBgEgCgBQgDgBgNAEIAAAAQACgfgaANQgCgMgDgGQgBgEgFABQgEgBgIADIAAgDQgBgDAAgDQgBgHgFgDIgBgBIgBABQgCAAAAgBIgJABQAAABgBAAQgCABgDAAIgDAAQAAgBABgCQABgFAAgFIAAgEQgBAAAAgBIAAgBQAAgCgJACQgHAAgEACIgBgGQgBgIgBgCQgEgHgVAHQAAgDgFgIQgIgXgXAUQgCgGgCgFQgDgIgIABQgIABgEAFQgBgHgDgGQgFgJgIABQgFAAgJAGQgDgCgCgGQgBgFAAgCIAAgBQAAgBgYAFIgEgLQgEgNgGAAIgCABQgFAAgFACQgGADgBgDQgCgHgGgCQgLAAgDACQgCABgBgBQgBgBgBgCQgDgFgFAAIAAAAQgFAAgIADQgBAAgCAAQgCABgBABQgBAAgBABQgDAAgEABIgHAFQgDBgA0A7QA2A+ByAaQB0AbB1gMIAvgP");
	this.shape.setTransform(25.1,13.7);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.blueglowback, new cjs.Rectangle(-1.5,-1.5,53.3,30.5), null);


(lib.IguanaHead_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 6
	this.instance = new lib.IguanaHead();
	this.instance.parent = this;
	this.instance.setTransform(-2,-2,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.IguanaHead_1, new cjs.Rectangle(-2,-2,54,52), null);


(lib.star_2_anim = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Star
	this.instance = new lib.SmallStar("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(0.1,0.3,0.6,0.6);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({guide:{path:[0.1,0.2,-4.2,-0.7,-6.2,-1.6,-9.1,-2.8,-9.1,-4.5,-9.1,-6.3,-6,-7.7,-4.2,-8.6,0.7,-10,5.6,-11.4,7.5,-12.3,10.6,-13.8,10.6,-15.6,10.6,-17.5,7.3,-18.9,5.3,-19.8,0.1,-21.1,-5.1,-22.4,-7,-23.2,-10.3,-24.5,-10.3,-26.3,-10.3,-28,-7.2,-29.3,-5.7,-30,-1.7,-31.1], orient:'auto'},alpha:0.102},16).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-5.1,-4.7,10.5,10);


(lib.star_1_anim = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Star
	this.instance = new lib.LargeStar("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(0.1,0.3,0.6,0.6);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({guide:{path:[0.1,0.2,4.5,-0.7,6.5,-1.6,9.4,-2.8,9.4,-4.5,9.4,-6.3,6.3,-7.7,4.5,-8.6,-0.4,-10,-5.3,-11.4,-7.2,-12.3,-10.3,-13.8,-10.3,-15.6,-10.3,-17.5,-7,-18.9,-5,-19.8,0.1,-21.1,5.4,-22.4,7.3,-23.2,10.6,-24.5,10.6,-26.3,10.6,-28,7.5,-29.3,6,-30,2,-31.1], orient:'auto'},alpha:0.102},13).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-6.9,-6.4,14,13.3);


(lib.sparkle2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.innerSparkle = new lib.star_2_anim();
	this.innerSparkle.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.innerSparkle).wait(1));

}).prototype = getMCSymbolPrototype(lib.sparkle2, new cjs.Rectangle(-5.2,-4.7,10.6,10), null);


(lib.sparkle1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.innerSparkle = new lib.star_1_anim();
	this.innerSparkle.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.innerSparkle).wait(1));

}).prototype = getMCSymbolPrototype(lib.sparkle1, new cjs.Rectangle(-6.9,-6.4,14,13.3), null);


(lib.Running_drop = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.instance = new lib.Wet_drop();
	this.instance.parent = this;
	this.instance.setTransform(4.8,10,1,1,0,0,0,4.8,10);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,4);
	new cjs.ButtonHelper(this.instance, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({y:146.2},15).to({regX:4.5,scaleX:0.1,scaleY:0.1,y:182.5},4).to({_off:true},1).wait(5));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-10,-10,37,48);


(lib.left_over_bubbles_sparse = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 15
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(59.6,9,0.075,0.075,-155.3,0,0,11.1,11.2);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(46.5,10.1,0.439,0.439,-153.7,0,0,11.2,11.1);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_2 = new lib.M_Wash_Bubble_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(55.1,9,0.162,0.162,-155.3,0,0,11.2,11.2);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_3 = new lib.M_Wash_Bubble_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(38.2,13,0.188,0.188,-155.4,0,0,11.1,10.7);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_4 = new lib.M_Wash_Bubble_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(40.7,8.6,0.28,0.28,-155.4,0,0,11.2,11.2);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_5 = new lib.M_Wash_Bubble_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(36.5,10.9,0.165,0.165,0,0,0,11,11);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.left_over_bubbles_sparse, new cjs.Rectangle(23.8,-13.3,50.1,48), null);


(lib.left_over_bubbles_2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 15
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(45.6,4.1,0.326,0.326,-155.4,0,0,11.3,11.2);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(52.8,6.1,0.28,0.28,-155.4,0,0,11.2,11.2);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.left_over_bubbles_2, new cjs.Rectangle(27.1,-14.9,46.8,40.7), null);


(lib.left_over_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 15
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(70.8,4,0.404,0.404,4.9,0,0,11.1,10.3);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(64.4,1.4,0.289,0.289,4.9,0,0,11.1,10.3);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_2 = new lib.M_Wash_Bubble_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(31,4.8,0.289,0.289,4.9,0,0,11.1,10);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_3 = new lib.M_Wash_Bubble_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(29.7,12.7,0.431,0.431,4.9,0,0,11.3,11.2);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_4 = new lib.M_Wash_Bubble_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(34.6,7,0.253,0.253,160.3,0,0,10.8,10.8);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_5 = new lib.M_Wash_Bubble_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(55.1,9,0.162,0.162,-155.3,0,0,11.2,11.2);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_6 = new lib.M_Wash_Bubble_1();
	this.instance_6.parent = this;
	this.instance_6.setTransform(47.2,-5.1,0.267,0.267,-155.4,0,0,11.5,11.1);
	this.instance_6.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_7 = new lib.M_Wash_Bubble_1();
	this.instance_7.parent = this;
	this.instance_7.setTransform(20.1,12.2,0.221,0.221,-155.4,0,0,11.3,11);
	this.instance_7.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_8 = new lib.M_Wash_Bubble_1();
	this.instance_8.parent = this;
	this.instance_8.setTransform(20.2,17,0.162,0.162,-155.3,0,0,11.2,11.1);
	this.instance_8.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_9 = new lib.M_Wash_Bubble_1();
	this.instance_9.parent = this;
	this.instance_9.setTransform(38.2,13,0.188,0.188,-155.4,0,0,11.1,10.7);
	this.instance_9.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_10 = new lib.M_Wash_Bubble_1();
	this.instance_10.parent = this;
	this.instance_10.setTransform(40.7,8.6,0.28,0.28,-155.4,0,0,11.2,11.2);
	this.instance_10.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_11 = new lib.M_Wash_Bubble_1();
	this.instance_11.parent = this;
	this.instance_11.setTransform(82.6,4.9,0.124,0.124,-155.3,0,0,10.5,11.2);
	this.instance_11.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_12 = new lib.M_Wash_Bubble_1();
	this.instance_12.parent = this;
	this.instance_12.setTransform(36.5,10.9,0.165,0.165,0,0,0,11,11);
	this.instance_12.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_12},{t:this.instance_11},{t:this.instance_10},{t:this.instance_9},{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.left_over_bubbles, new cjs.Rectangle(5.3,-21.9,91.8,57.3), null);


(lib.IguanaBackLegLower = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":61,"glowclean":62,"glowclean_loop":63,"final":64,"final_loop":65});

	// Layer 4
	this.instance = new lib.IguanaBackLegLower0001();
	this.instance.parent = this;
	this.instance.setTransform(-1.7,-2.9,0.5,0.5);

	this.instance_1 = new lib.left_over_bubbles_sparse();
	this.instance_1.parent = this;
	this.instance_1.setTransform(74,8.2,0.25,0.25,-105,0,0,47.6,10.1);

	this.instance_2 = new lib.left_over_bubbles_2();
	this.instance_2.parent = this;
	this.instance_2.setTransform(65.8,10.3,0.5,0.5,-105,0,0,49,5);

	this.instance_3 = new lib.left_over_bubbles();
	this.instance_3.parent = this;
	this.instance_3.setTransform(17.6,7.6,0.25,0.25,0,0,0,50.6,5.2);

	this.instance_4 = new lib.IguanaBackLegLower0002();
	this.instance_4.parent = this;
	this.instance_4.setTransform(-1.7,-2.9,0.5,0.5);

	this.instance_5 = new lib.iguana_legGlow();
	this.instance_5.parent = this;
	this.instance_5.setTransform(39.7,-2.9,1.562,1.562,0,0,180,-3.9,-1.8);

	this.glow = new lib.blueglowlegs();
	this.glow.parent = this;
	this.glow.setTransform(39.7,-2.9,1.562,1.562,0,0,180,-3.9,-1.8);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]},2).to({state:[{t:this.instance},{t:this.instance_5}]},2).to({state:[{t:this.instance_4}]},2).to({state:[{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]},7).to({state:[{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]},48).to({state:[{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.glow}]},1).to({state:[{t:this.instance_4}]},2).to({state:[]},2).wait(149));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-1.7,-2.9,42,27);


(lib.Bubbles_together = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// M_Wash_Bubble
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(30.1,18.9,0.303,0.303,-155.3,0,0,11,10.9);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_pop_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(30.2,18.9,0.757,0.757,-155.3,0,0,10.9,11);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance}]},38).to({state:[{t:this.instance_1}]},2).to({state:[]},2).wait(50));
	this.timeline.addTween(cjs.Tween.get(this.instance).to({regX:10.9,regY:11,scaleX:0.76,scaleY:0.76,x:30.2},38).to({_off:true},2).wait(52));

	// M_Wash_Bubble
	this.instance_2 = new lib.M_Wash_Bubble_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(24.5,20.9,0.313,0.313,-155.3,0,0,11.1,11.1);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_3 = new lib.M_Wash_Bubble_pop_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(24.6,20.9,0.757,0.757,-155.3,0,0,11,11);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2}]}).to({state:[{t:this.instance_2}]},40).to({state:[{t:this.instance_3}]},2).to({state:[]},2).wait(48));
	this.timeline.addTween(cjs.Tween.get(this.instance_2).to({regX:11,regY:11,scaleX:0.76,scaleY:0.76,x:24.6},40).to({_off:true},2).wait(50));

	// M_Wash_Bubble
	this.instance_4 = new lib.M_Wash_Bubble_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(39.6,16.1,0.287,0.287,-155.3,0,0,10.8,10.8);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_5 = new lib.M_Wash_Bubble_pop_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(39.6,16.1,0.757,0.757,-155.3,0,0,11,11);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_4}]}).to({state:[{t:this.instance_4}]},34).to({state:[{t:this.instance_5}]},2).to({state:[]},2).wait(54));
	this.timeline.addTween(cjs.Tween.get(this.instance_4).to({regX:11,regY:11,scaleX:0.76,scaleY:0.76},34).to({_off:true},2).wait(56));

	// M_Wash_Bubble
	this.instance_6 = new lib.M_Wash_Bubble_1();
	this.instance_6.parent = this;
	this.instance_6.setTransform(9.9,-2.5,0.199,0.199,-155.3,0,0,11,10.7);
	this.instance_6.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_7 = new lib.M_Wash_Bubble_pop_1();
	this.instance_7.parent = this;
	this.instance_7.setTransform(9.8,-2.5,0.757,0.757,-155.3,0,0,11.1,11);
	this.instance_7.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_6}]}).to({state:[{t:this.instance_7}]},32).to({state:[{t:this.instance_7}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_6).to({_off:true,regX:11.1,regY:11,scaleX:0.76,scaleY:0.76,x:9.8},32).wait(60));

	// M_Wash_Bubble
	this.instance_8 = new lib.M_Wash_Bubble_1();
	this.instance_8.parent = this;
	this.instance_8.setTransform(25.7,-1.5,0.162,0.162,-155.3,0,0,11.2,11.2);
	this.instance_8.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_9 = new lib.M_Wash_Bubble_pop_1();
	this.instance_9.parent = this;
	this.instance_9.setTransform(25.6,-1.5,0.757,0.757,-155.3,0,0,11.1,11);
	this.instance_9.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_8}]}).to({state:[{t:this.instance_9}]},36).to({state:[{t:this.instance_9}]},2).to({state:[]},2).wait(52));
	this.timeline.addTween(cjs.Tween.get(this.instance_8).to({_off:true,regX:11.1,regY:11,scaleX:0.76,scaleY:0.76,x:25.6},36).wait(56));

	// M_Wash_Bubble
	this.instance_10 = new lib.M_Wash_Bubble_1();
	this.instance_10.parent = this;
	this.instance_10.setTransform(22.2,6,0.108,0.108,-155.3,0,0,11.1,11.8);
	this.instance_10.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_11 = new lib.M_Wash_Bubble_pop_1();
	this.instance_11.parent = this;
	this.instance_11.setTransform(22,6,0.757,0.757,-155.3,0,0,11.2,10.9);
	this.instance_11.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_10}]}).to({state:[{t:this.instance_11}]},30).to({state:[{t:this.instance_11}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_10).to({_off:true,regX:11.2,regY:10.9,scaleX:0.76,scaleY:0.76,x:22},30).wait(62));

	// M_Wash_Bubble
	this.instance_12 = new lib.M_Wash_Bubble_1();
	this.instance_12.parent = this;
	this.instance_12.setTransform(29.2,-9,0.119,0.119,-155.3,0,0,11.5,11);
	this.instance_12.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_13 = new lib.M_Wash_Bubble_pop_1();
	this.instance_13.parent = this;
	this.instance_13.setTransform(29.1,-9,0.757,0.757,-155.3,0,0,11.1,11);
	this.instance_13.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_12}]}).to({state:[{t:this.instance_13}]},32).to({state:[{t:this.instance_13}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_12).to({_off:true,regX:11.1,scaleX:0.76,scaleY:0.76,x:29.1},32).wait(60));

	// M_Wash_Bubble
	this.instance_14 = new lib.M_Wash_Bubble_1();
	this.instance_14.parent = this;
	this.instance_14.setTransform(42.2,-3.1,0.271,0.271,-155.3,0,0,10.3,11.3);
	this.instance_14.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_15 = new lib.M_Wash_Bubble_pop_1();
	this.instance_15.parent = this;
	this.instance_15.setTransform(42.2,-3.1,0.757,0.757,-155.3,0,0,11,11.1);
	this.instance_15.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_14}]}).to({state:[{t:this.instance_15}]},30).to({state:[{t:this.instance_15}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_14).to({_off:true,regX:11,regY:11.1,scaleX:0.76,scaleY:0.76},30).wait(62));

	// M_Wash_Bubble
	this.instance_16 = new lib.M_Wash_Bubble_1();
	this.instance_16.parent = this;
	this.instance_16.setTransform(48.3,9,0.125,0.125,-155.3,0,0,11,10.5);
	this.instance_16.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_16).to({regY:11,scaleX:0.76,scaleY:0.76,x:48.4,y:8.9},24).wait(2).to({_off:true},2).wait(64));

	// M_Wash_Bubble
	this.instance_17 = new lib.M_Wash_Bubble_1();
	this.instance_17.parent = this;
	this.instance_17.setTransform(32.6,-16.6,0.076,0.076,-155.3,0,0,10.8,11);
	this.instance_17.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_17).to({regX:11,regY:11.1,scaleX:0.76,scaleY:0.76,y:-16.7},20).wait(2).to({_off:true},2).wait(68));

	// M_Wash_Bubble
	this.instance_18 = new lib.M_Wash_Bubble_1();
	this.instance_18.parent = this;
	this.instance_18.setTransform(35.5,5.1,0.103,0.103,-155.3,0,0,10.3,10.8);
	this.instance_18.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_18).to({regX:11,regY:11.1,scaleX:0.76,scaleY:0.76,x:32.6,y:7.6},22).wait(2).to({regY:11,x:35.5,y:5.1},0).to({_off:true},2).wait(66));

	// M_Wash_Bubble
	this.instance_19 = new lib.M_Wash_Bubble_1();
	this.instance_19.parent = this;
	this.instance_19.setTransform(56,0.3,0.124,0.124,-155.3,0,0,10.5,11.2);
	this.instance_19.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_20 = new lib.M_Wash_Bubble_pop_1();
	this.instance_20.parent = this;
	this.instance_20.setTransform(52,-4.5,0.686,0.686,-155.4,0,0,10.3,11.2);
	this.instance_20.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_19}]}).to({state:[{t:this.instance_19}]},24).to({state:[{t:this.instance_20}]},2).to({state:[]},2).wait(64));
	this.timeline.addTween(cjs.Tween.get(this.instance_19).to({regX:10.3,scaleX:0.69,scaleY:0.69,rotation:-155.4,x:52,y:-4.5},24).to({_off:true},2).wait(66));

	// M_Wash_Bubble
	this.instance_21 = new lib.M_Wash_Bubble_1();
	this.instance_21.parent = this;
	this.instance_21.setTransform(52.4,20,0.067,0.067,-155.3,0,0,11.8,11.1);
	this.instance_21.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_22 = new lib.M_Wash_Bubble_pop_1();
	this.instance_22.parent = this;
	this.instance_22.setTransform(52.4,19.8,0.757,0.757,-155.3,0,0,11.2,11.2);
	this.instance_22.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_21}]}).to({state:[{t:this.instance_21}]},22).to({state:[{t:this.instance_22}]},8).to({state:[{t:this.instance_22}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_21).to({regX:11.7,regY:11.2,scaleX:0.53,scaleY:0.53,rotation:-155.4,x:46.9,y:21.6},22).to({_off:true,regX:11.2,scaleX:0.76,scaleY:0.76,rotation:-155.3,x:52.4,y:19.8},8).wait(62));

	// M_Wash_Bubble
	this.instance_23 = new lib.M_Wash_Bubble_1();
	this.instance_23.parent = this;
	this.instance_23.setTransform(38.5,-8.5,0.4,0.4,0,0,0,11,11);
	this.instance_23.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_24 = new lib.M_Wash_Bubble_pop_1();
	this.instance_24.parent = this;
	this.instance_24.setTransform(38.5,-8.5,1,1,0,0,0,11,11);
	this.instance_24.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_23}]}).to({state:[{t:this.instance_23}]},38).to({state:[{t:this.instance_24}]},2).to({state:[]},2).wait(50));
	this.timeline.addTween(cjs.Tween.get(this.instance_23).to({scaleX:1,scaleY:1},38).to({_off:true},2).wait(52));

	// M_Wash_Bubble
	this.instance_25 = new lib.M_Wash_Bubble_1();
	this.instance_25.parent = this;
	this.instance_25.setTransform(44,-14,0.413,0.413,0,0,0,11,11);
	this.instance_25.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_26 = new lib.M_Wash_Bubble_pop_1();
	this.instance_26.parent = this;
	this.instance_26.setTransform(44,-14,1,1,0,0,0,11,11);
	this.instance_26.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_25}]}).to({state:[{t:this.instance_25}]},40).to({state:[{t:this.instance_26}]},2).to({state:[]},2).wait(48));
	this.timeline.addTween(cjs.Tween.get(this.instance_25).to({scaleX:1,scaleY:1},40).to({_off:true},2).wait(50));

	// M_Wash_Bubble
	this.instance_27 = new lib.M_Wash_Bubble_1();
	this.instance_27.parent = this;
	this.instance_27.setTransform(28.7,0,0.379,0.379,0,0,0,11,11);
	this.instance_27.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_28 = new lib.M_Wash_Bubble_pop_1();
	this.instance_28.parent = this;
	this.instance_28.setTransform(28.7,0,1,1,0,0,0,11,11);
	this.instance_28.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_27}]}).to({state:[{t:this.instance_27}]},34).to({state:[{t:this.instance_28}]},2).to({state:[]},2).wait(54));
	this.timeline.addTween(cjs.Tween.get(this.instance_27).to({scaleX:1,scaleY:1},34).to({_off:true},2).wait(56));

	// M_Wash_Bubble
	this.instance_29 = new lib.M_Wash_Bubble_1();
	this.instance_29.parent = this;
	this.instance_29.setTransform(74.5,6,0.263,0.263,0,0,0,11,11);
	this.instance_29.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_30 = new lib.M_Wash_Bubble_pop_1();
	this.instance_30.parent = this;
	this.instance_30.setTransform(74.5,6,1,1,0,0,0,11,11);
	this.instance_30.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_29}]}).to({state:[{t:this.instance_30}]},32).to({state:[{t:this.instance_30}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_29).to({_off:true,scaleX:1,scaleY:1},32).wait(60));

	// M_Wash_Bubble
	this.instance_31 = new lib.M_Wash_Bubble_1();
	this.instance_31.parent = this;
	this.instance_31.setTransform(54.9,13.5,0.214,0.214,0,0,0,11,11.2);
	this.instance_31.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_32 = new lib.M_Wash_Bubble_pop_1();
	this.instance_32.parent = this;
	this.instance_32.setTransform(54.9,13.5,1,1,0,0,0,11,11);
	this.instance_32.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_31}]}).to({state:[{t:this.instance_32}]},36).to({state:[{t:this.instance_32}]},2).to({state:[]},2).wait(52));
	this.timeline.addTween(cjs.Tween.get(this.instance_31).to({_off:true,regY:11,scaleX:1,scaleY:1},36).wait(56));

	// M_Wash_Bubble
	this.instance_33 = new lib.M_Wash_Bubble_1();
	this.instance_33.parent = this;
	this.instance_33.setTransform(55,2.5,0.143,0.143,0,0,0,10.8,11.2);
	this.instance_33.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_34 = new lib.M_Wash_Bubble_pop_1();
	this.instance_34.parent = this;
	this.instance_34.setTransform(55,2.5,1,1,0,0,0,11,11);
	this.instance_34.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_33}]}).to({state:[{t:this.instance_34}]},30).to({state:[{t:this.instance_34}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_33).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},30).wait(62));

	// M_Wash_Bubble
	this.instance_35 = new lib.M_Wash_Bubble_1();
	this.instance_35.parent = this;
	this.instance_35.setTransform(54.9,24.5,0.157,0.157,0,0,0,11.2,11.2);
	this.instance_35.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_36 = new lib.M_Wash_Bubble_pop_1();
	this.instance_36.parent = this;
	this.instance_36.setTransform(54.9,24.5,1,1,0,0,0,11,11);
	this.instance_36.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_35}]}).to({state:[{t:this.instance_36}]},32).to({state:[{t:this.instance_36}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_35).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},32).wait(60));

	// M_Wash_Bubble
	this.instance_37 = new lib.M_Wash_Bubble_1();
	this.instance_37.parent = this;
	this.instance_37.setTransform(36,24.5,0.357,0.357,0,0,0,10.2,11.1);
	this.instance_37.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_38 = new lib.M_Wash_Bubble_pop_1();
	this.instance_38.parent = this;
	this.instance_38.setTransform(36,24.5,1,1,0,0,0,11,11);
	this.instance_38.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_37}]}).to({state:[{t:this.instance_38}]},30).to({state:[{t:this.instance_38}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_37).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},30).wait(62));

	// M_Wash_Bubble
	this.instance_39 = new lib.M_Wash_Bubble_1();
	this.instance_39.parent = this;
	this.instance_39.setTransform(22,13.5,0.165,0.165,0,0,0,10.9,11);
	this.instance_39.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_39).to({regY:10.9,scaleX:0.91,scaleY:0.91,x:18.6,y:13.3},22).to({regX:11,regY:11,scaleX:1,scaleY:1,x:22,y:13.5},2).wait(2).to({_off:true},2).wait(64));

	// M_Wash_Bubble
	this.instance_40 = new lib.M_Wash_Bubble_1();
	this.instance_40.parent = this;
	this.instance_40.setTransform(39.7,11,0.136,0.136,0,0,0,11.1,11.1);
	this.instance_40.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_40).to({regX:11,regY:11,scaleX:1,scaleY:1},22).wait(2).to({_off:true},2).wait(66));

	// M_Wash_Bubble
	this.instance_41 = new lib.M_Wash_Bubble_1();
	this.instance_41.parent = this;
	this.instance_41.setTransform(17.7,28,0.164,0.164,0,0,0,10.7,11);
	this.instance_41.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_41).to({regX:11,scaleX:1,scaleY:1},24).wait(2).to({_off:true},2).wait(64));

	// M_Wash_Bubble
	this.instance_42 = new lib.M_Wash_Bubble_1();
	this.instance_42.parent = this;
	this.instance_42.setTransform(11,2.5,0.088,0.088,0,0,0,10.8,10.8);
	this.instance_42.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_43 = new lib.M_Wash_Bubble_pop_1();
	this.instance_43.parent = this;
	this.instance_43.setTransform(11,2.5,1,1,0,0,0,11,11);
	this.instance_43.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_42}]}).to({state:[{t:this.instance_43}]},30).to({state:[{t:this.instance_43}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_42).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},30).wait(62));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-11.2,-37.9,114.4,94.8);


(lib.IguanaTorso_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"wash":0,"wash_stop":50});

	// Layer 2
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(29.2,42.8,0.721,0.723,0,-31.6,-31.8,35.6,11);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(55.6,11,0.721,0.723,0,143.6,143.4,35.9,10.9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_1},{t:this.instance}]},1).to({state:[]},49).wait(45));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.IguanaTorso = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":60,"glowclean":61,"glowclean_loop":62,"final":63,"final_loop":64});

	// Layer 4
	this.instance = new lib.IguanaTorso0001();
	this.instance.parent = this;
	this.instance.setTransform(-3.9,0.8,0.5,0.5);

	this.instance_1 = new lib.left_over_bubbles();
	this.instance_1.parent = this;
	this.instance_1.setTransform(50.1,36.2,1,1,-30,0,0,50.6,5.2);

	this.instance_2 = new lib.IguanaTorso0002();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-3.9,0.8,0.5,0.5);

	this.instance_3 = new lib.iguana_backGlow();
	this.instance_3.parent = this;
	this.instance_3.setTransform(39.8,30.4,1.634,1.634,0,-7.2,172.8,25,13.8);

	this.glow = new lib.blueglowback();
	this.glow.parent = this;
	this.glow.setTransform(39.8,30.4,1.634,1.634,0,-7.2,172.8,25,13.8);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_2},{t:this.instance_1}]},2).to({state:[{t:this.instance},{t:this.instance_3}]},2).to({state:[{t:this.instance_2}]},2).to({state:[{t:this.instance_2},{t:this.instance_1}]},5).to({state:[{t:this.instance_2},{t:this.instance_1}]},49).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.glow}]},1).to({state:[{t:this.instance_2}]},2).to({state:[]},2).wait(191));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-10.6,-6,124.9,94.8);


(lib.IguanaTail_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"wash":0,"wash_stop":50});

	// Layer 4
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(10.5,29,0.427,0.428,0,-11.4,-11.6,35.7,11);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(40.6,23.1,0.563,0.564,0,-110.2,-110.3,35.8,11);

	this.instance_2 = new lib.Bubbles_together();
	this.instance_2.parent = this;
	this.instance_2.setTransform(68.2,24.7,0.607,0.609,0,-45.9,-46,35.8,10.8);

	this.instance_3 = new lib.Bubbles_together();
	this.instance_3.parent = this;
	this.instance_3.setTransform(92.8,13.8,0.607,0.609,0,163.8,163.6,35.8,10.9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},1).to({state:[]},49).wait(44));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.IguanaTail = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":62,"glowclean":63,"glowclean_loop":64,"final":65,"final_loop":66});

	// Layer 6
	this.instance = new lib.IguanaTail0001();
	this.instance.parent = this;
	this.instance.setTransform(-2.1,-3,0.5,0.5);

	this.instance_1 = new lib.left_over_bubbles_2();
	this.instance_1.parent = this;
	this.instance_1.setTransform(59.5,21,0.5,0.5,0,0,0,48.9,4.9);

	this.instance_2 = new lib.left_over_bubbles();
	this.instance_2.parent = this;
	this.instance_2.setTransform(44,22.5,0.25,0.25,0,0,0,50.8,5.4);

	this.instance_3 = new lib.IguanaTail0002();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-2.1,-3,0.5,0.5);

	this.instance_4 = new lib.iguana_tailGlow();
	this.instance_4.parent = this;
	this.instance_4.setTransform(69.1,14.9,1.717,1.717,0,0,180,46.9,10.1);

	this.glow = new lib.blueglowtail();
	this.glow.parent = this;
	this.glow.setTransform(69.1,14.9,1.717,1.717,0,0,180,46.9,10.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]},2).to({state:[{t:this.instance},{t:this.instance_4}]},2).to({state:[{t:this.instance_3}]},2).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]},3).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]},53).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.glow}]},1).to({state:[{t:this.instance_3}]},2).to({state:[]},2).wait(239));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-2.1,-3,155,40);


(lib.IguanaNeck_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"wash":0,"wash_stop":38});

	// Layer 3
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(12.6,13.5,0.588,0.59,0,-11.4,-11.6,35.6,10.9);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1).to({_off:false},0).to({_off:true},37).wait(56));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.IguanaNeck = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":61,"glowclean":62,"glowclean_loop":63,"final":64,"final_loop":65});

	// Layer 5
	this.instance = new lib.IguanaNeck0001();
	this.instance.parent = this;
	this.instance.setTransform(-2.1,-2.1,0.5,0.5);

	this.instance_1 = new lib.left_over_bubbles_2();
	this.instance_1.parent = this;
	this.instance_1.setTransform(13.1,21.9,1,1,-60,0,0,48.8,4.9);

	this.instance_2 = new lib.IguanaNeck0002();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-2.1,-2.1,0.5,0.5);

	this.instance_3 = new lib.iguana_neckGlow();
	this.instance_3.parent = this;
	this.instance_3.setTransform(16,21.2,1.643,1.643,0,0,180,10,13.9);

	this.glow = new lib.blueglowneck();
	this.glow.parent = this;
	this.glow.setTransform(16,21.2,1.643,1.643,0,0,180,10,13.9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_2},{t:this.instance_1}]},2).to({state:[{t:this.instance},{t:this.instance_3}]},2).to({state:[{t:this.instance_2}]},2).to({state:[{t:this.instance_2},{t:this.instance_1}]},6).to({state:[{t:this.instance_2},{t:this.instance_1}]},49).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.glow}]},1).to({state:[{t:this.instance_2}]},2).to({state:[]},2).wait(240));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-2.1,-2.1,47,53);


(lib.water_drops_010 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.instance = new lib.Running_drop();
	this.instance.parent = this;
	this.instance.setTransform(204.8,4.9,0.486,0.486,0,0,180,4.7,10.1);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(7).to({_off:false},0).to({_off:true},24).wait(2));

	// WET DROPS
	this.instance_1 = new lib.Running_drop();
	this.instance_1.parent = this;
	this.instance_1.setTransform(103.6,36.6,0.486,0.486,0,0,180,4.8,10.1);
	this.instance_1._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(4).to({_off:false},0).to({_off:true},24).wait(5));

	// WET DROPS
	this.instance_2 = new lib.Running_drop();
	this.instance_2.parent = this;
	this.instance_2.setTransform(171.9,-4.8,0.486,0.486,0,0,0,4.8,10.1);
	this.instance_2._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(6).to({_off:false},0).to({_off:true},24).wait(3));

	// WET DROPS
	this.instance_3 = new lib.Running_drop();
	this.instance_3.parent = this;
	this.instance_3.setTransform(151.3,15.9,0.486,0.486,0,0,0,4.7,10.1);
	this.instance_3._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(3).to({_off:false},0).to({_off:true},24).wait(6));

	// WET DROPS
	this.instance_4 = new lib.Running_drop();
	this.instance_4.parent = this;
	this.instance_4.setTransform(132.4,26.9,0.486,0.486,0,0,0,4.8,10.1);

	this.timeline.addTween(cjs.Tween.get(this.instance_4).to({_off:true},24).wait(9));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(125.1,17,18,23);


(lib.IguanaBackLegLower_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"wash":0,"wash_stop":69});

	// Layer 3
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(71.9,3.9,0.399,0.415,0,-57.3,-52.7,36.4,4.2);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(70,7.7,0.399,0.415,0,174.4,179.1,36.5,4.2);

	this.instance_2 = new lib.Bubbles_together();
	this.instance_2.parent = this;
	this.instance_2.setTransform(23.9,3.9,0.399,0.415,0,174.4,179.1,36.4,3.6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},1).to({state:[]},68).wait(44));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.iguana_legMud_001_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{mud:0,soap:45,"clean":57});

	// timeline functions:
	this.frame_0 = function() {
		/* stop();*/
	}
	this.frame_45 = function() {
		/* stop();*/
	}
	this.frame_57 = function() {
		/* stop();*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(45).call(this.frame_45).wait(12).call(this.frame_57).wait(12));

	// Layer 1
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(47.9,2.5,0.399,0.415,0,-57.3,-52.7,36.4,4.2);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(46,6.3,0.399,0.415,0,174.4,179.1,36.5,4.2);

	this.instance_2 = new lib.Bubbles_together();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-0.1,2.4,0.399,0.415,0,174.4,179.1,36.4,3.6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},1).to({state:[]},44).to({state:[]},7).wait(17));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.Iguana = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{wrongAnswer:0,rest:30,rest_stop:140,wet:142,wet_stop:152,"clean":154,clean_stop:166,excited:168,excited_stop:378,animalSound:380});

	// timeline functions:
	this.frame_28 = function() {
		/* gotoAndPlay("rest");*/
	}
	this.frame_140 = function() {
		/* stop();
		
		gameObjects._animal.restTimeout();*/
	}
	this.frame_152 = function() {
		/* stop();*/
	}
	this.frame_166 = function() {
		/* stop();*/
	}
	this.frame_378 = function() {
		/* 
		
		gameObjects._game.done();
		stop();*/
	}
	this.frame_407 = function() {
		/* gotoAndPlay("rest");*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).wait(28).call(this.frame_28).wait(112).call(this.frame_140).wait(12).call(this.frame_152).wait(14).call(this.frame_166).wait(212).call(this.frame_378).wait(29).call(this.frame_407).wait(1));

	// Layer 4
	this.instance = new lib.water_drops_010();
	this.instance.parent = this;
	this.instance.setTransform(522,141.2,0.3,0.3,0,0,180,92.5,49.2);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(142).to({_off:false},0).to({_off:true},12).wait(254));

	// sparkle
	this.instance_1 = new lib.sparkle();
	this.instance_1.parent = this;
	this.instance_1.setTransform(492.3,119.5,0.263,0.263);
	this.instance_1._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(291).to({_off:false},0).wait(117));

	// sparkle
	this.instance_2 = new lib.sparkle();
	this.instance_2.parent = this;
	this.instance_2.setTransform(535.5,145,0.393,0.393);
	this.instance_2._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(302).to({_off:false},0).wait(106));

	// sparkle
	this.instance_3 = new lib.sparkle();
	this.instance_3.parent = this;
	this.instance_3.setTransform(569.3,152.3,0.509,0.509);
	this.instance_3._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(282).to({_off:false},0).wait(126));

	// Layer 5
	this.legs_bubbles = new lib.IguanaBackLegLower_bubbles();
	this.legs_bubbles.parent = this;
	this.legs_bubbles.setTransform(514.5,148.5,0.412,0.412,0,0,180,31.2,1.9);

	this.timeline.addTween(cjs.Tween.get(this.legs_bubbles).wait(30).to({_off:true},112).wait(266));

	// sparkle
	this.instance_4 = new lib.sparkle();
	this.instance_4.parent = this;
	this.instance_4.setTransform(510.5,137.6,0.555,0.555);
	this.instance_4._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_4).wait(274).to({_off:false},0).wait(134));

	// Iguana Tail
	this.tail_bubbles = new lib.IguanaTail_bubbles();
	this.tail_bubbles.parent = this;
	this.tail_bubbles.setTransform(531.5,146.9,0.412,0.412,0,0,180,140.2,8.1);

	this.timeline.addTween(cjs.Tween.get(this.tail_bubbles).wait(30).to({_off:true},112).wait(266));

	// Iguana Torso
	this.back_bubbles = new lib.IguanaTorso_bubbles();
	this.back_bubbles.parent = this;
	this.back_bubbles.setTransform(522.2,147.8,0.412,0.412,0,-7.1,172.9,30.2,59.2);

	this.timeline.addTween(cjs.Tween.get(this.back_bubbles).wait(30).to({_off:true},112).wait(266));

	// Iguana Neck
	this.neck_bubbles = new lib.IguanaNeck_bubbles();
	this.neck_bubbles.parent = this;
	this.neck_bubbles.setTransform(496.6,129.6,0.412,0.412,0,0,180,11.7,32.5);

	this.timeline.addTween(cjs.Tween.get(this.neck_bubbles).wait(30).to({_off:true},112).wait(266));

	// Iguana Head
	this.instance_5 = new lib.IguanaHead_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(493.3,126.2,0.412,0.412,0,0,180,-1.6,29.7);

	this.timeline.addTween(cjs.Tween.get(this.instance_5).wait(4).to({regY:29.4,skewX:1.8,skewY:181.8,x:494.8,y:126.9},0).wait(2).to({regY:29.6,skewX:3.8,skewY:183.8,x:496.2,y:127.8},0).wait(2).to({regX:-1.7,regY:29.8,skewX:5.7,skewY:185.7,x:497.7,y:128.6},0).wait(8).to({regX:-1.6,regY:29.6,skewX:3.8,skewY:183.8,x:496.2,y:127.8},0).wait(2).to({regY:29.4,skewX:1.8,skewY:181.8,x:494.8,y:126.9},0).wait(2).to({regY:29.7,skewX:0,skewY:180,x:493.3,y:126.2},0).wait(60).to({regX:-1.4,skewX:-4,skewY:176,x:493.1,y:125.8},0).wait(2).to({regX:-1.1,regY:29.8,skewX:-8.3,skewY:171.7,x:492.7,y:125.3},0).wait(2).to({regX:-1.8,skewX:-12.5,skewY:167.5,x:492.8,y:124.9},0).wait(2).to({regX:-1.6,regY:29.6,skewX:-16.7,skewY:163.3,x:492.6,y:124.3},0).wait(2).to({regY:29.4,skewX:-16.6,skewY:163.4,y:124.2},0).wait(30).to({regY:29.6,skewX:-16.7,skewY:163.3,y:124.3},0).wait(2).to({regX:-1.4,regY:29.7,skewX:-13.3,skewY:166.7,x:492.7,y:124.8},0).wait(2).to({regX:-1.5,regY:29.8,skewX:-10,skewY:170,x:492.9,y:125.3},0).wait(2).to({regX:-1.4,regY:29.5,skewX:-6.5,skewY:173.5,y:125.7},0).wait(2).to({skewX:-3.3,skewY:176.7,x:493.1,y:126.2},0).wait(2).to({regX:-1.6,regY:29.8,skewX:0,skewY:180,x:493.3,y:126.8},0).wait(2).to({regY:29.7,y:126.6},0).wait(2).to({regY:29.8,y:126.4},0).wait(2).to({regY:29.7,y:126.2},0).wait(48).to({regY:29.4,skewX:1.8,skewY:181.8,x:494.8,y:126.9},0).wait(2).to({regY:29.6,skewX:3.8,skewY:183.8,x:496.2,y:127.8},0).wait(2).to({regX:-1.7,regY:29.8,skewX:5.7,skewY:185.7,x:497.7,y:128.6},0).wait(4).to({regX:-1.9,skewX:15,skewY:195,x:493.3,y:126.3},0).wait(2).to({regX:-1.8,regY:29.6,skewX:22.3,skewY:202.3,x:494.6,y:124.3},0).wait(2).to({regX:-1.7,skewX:30,skewY:210,x:495.8,y:122.5},0).wait(6).to({regY:29.4,skewX:1.2,skewY:181.2,x:494.6,y:124.1},0).wait(2).to({regX:-1.8,skewX:-15.8,skewY:164.2,x:493.9,y:125.2},0).wait(2).to({regY:29.7,skewX:-21.7,skewY:158.3,x:493.7,y:125.6},0).wait(2).to({skewX:-3.3,skewY:176.7,x:494.7,y:124},0).wait(2).to({regX:-1.6,regY:29.6,skewX:15,skewY:195,x:495.8,y:122.5},0).wait(2).to({regX:-2.2,regY:29.4,skewX:5.8,skewY:185.8,y:123.1},0).wait(2).to({regX:-1.7,regY:29.5,skewX:-3.3,skewY:176.7,x:495.3,y:123.8},0).wait(2).to({regX:-1.8,skewX:-12.5,skewY:167.5,x:495,y:124.5},0).wait(2).to({regX:-1.6,regY:29.7,skewX:-21.7,skewY:158.3,x:494.8,y:125.2},0).wait(2).to({regX:-1.5,skewX:-9.3,skewY:170.7,x:495.1,y:124.3},0).wait(2).to({regX:-1.6,skewX:2.7,skewY:182.7,x:495.5,y:123.4},0).wait(2).to({regY:29.6,skewX:15,skewY:195,x:495.8,y:122.5},0).wait(2).to({regX:-1.4,regY:29.7,skewX:2.8,skewY:182.8,x:495.4,y:123.4},0).wait(2).to({regX:-2.1,regY:28.9,skewX:-9.3,skewY:170.7,x:495.2,y:123.9},0).wait(2).to({regX:-1.6,regY:29.7,skewX:-21.7,skewY:158.3,x:494.8,y:125.2},0).wait(2).to({regX:-1.5,skewX:-9.3,skewY:170.7,x:495.1,y:124.3},0).wait(2).to({regX:-1.6,skewX:2.7,skewY:182.7,x:495.5,y:123.4},0).wait(2).to({regY:29.6,skewX:15,skewY:195,x:495.8,y:122.5},0).wait(2).to({regX:-3.3,regY:29.8,skewX:9.8,skewY:189.8,x:495.6,y:124},0).wait(2).to({regX:-1.8,regY:29.6,skewX:4.8,skewY:184.8,x:494.2,y:124.9},0).wait(2).to({regX:-1.6,regY:29.7,skewX:0,skewY:180,x:493.3,y:126.2},0).wait(168));

	// Iguana Back Foot
	this.instance_6 = new lib.IguanaBackFoot_1();
	this.instance_6.parent = this;
	this.instance_6.setTransform(525.6,155.1,0.412,0.412,0,0,180,4.1,3);

	this.timeline.addTween(cjs.Tween.get(this.instance_6).wait(408));

	// Iguana Back Leg Lower
	this.iguana_hindleg = new lib.IguanaBackLegLower();
	this.iguana_hindleg.parent = this;
	this.iguana_hindleg.setTransform(514.5,148.5,0.412,0.412,0,0,180,31.2,1.9);

	this.timeline.addTween(cjs.Tween.get(this.iguana_hindleg).wait(4).to({scaleX:0.42,skewY:183.8,y:147.7},0).wait(2).to({scaleX:0.42,skewY:187.5,y:146.8},0).wait(2).to({scaleX:0.42,skewY:191.4,y:145.9},0).wait(8).to({scaleX:0.42,skewY:187.5,y:146.8},0).wait(2).to({scaleX:0.42,skewY:183.8,y:147.7},0).wait(2).to({scaleX:0.41,skewY:180,y:148.5},0).wait(60).to({regX:30.9,skewX:1.3,skewY:181.3,x:514.6,y:148.3},0).wait(2).to({regX:31.1,regY:3.7,skewX:2.6,skewY:182.6,x:514.7,y:148.9},0).wait(2).to({regX:31.3,regY:1.9,skewX:4,skewY:184,y:148.1},0).wait(2).to({regX:31.2,regY:2,skewX:5.4,skewY:185.4,x:514.8,y:147.9},0).wait(2).to({regX:33.2,regY:2.1,skewX:5.3,skewY:185.3,x:514.1},0).wait(30).to({regX:31.2,regY:2,skewX:5.4,skewY:185.4,x:514.8},0).wait(2).to({regX:31.3,skewX:4.8,skewY:184.8,y:148},0).wait(2).to({regX:31.4,skewX:4,skewY:184,x:514.7},0).wait(2).to({regX:31.2,regY:1.9,skewX:3.3,skewY:183.3,y:148.1},0).wait(2).to({regX:31.4,regY:2,skewX:2.6,skewY:182.6,y:148.2},0).wait(2).to({regY:1.9,skewX:2,skewY:182,x:514.6,y:148.3},0).wait(2).to({regX:31.2,skewX:1.3,skewY:181.3,x:514.7},0).wait(2).to({regX:30.7,regY:2,skewX:0.5,skewY:180.5,x:514.8,y:148.4},0).wait(2).to({regX:31.2,regY:1.9,skewX:0,skewY:180,x:514.5,y:148.5},0).wait(48).to({scaleX:0.42,skewY:183.8,y:147.7},0).wait(2).to({scaleX:0.42,skewY:187.5,y:146.8},0).wait(2).to({scaleX:0.42,skewY:191.4,y:145.9},0).wait(4).to({scaleX:0.41,skewY:180,y:148.5},0).wait(2).to({skewX:3.8,skewY:183.8,y:147.7},0).wait(2).to({regX:31.1,skewX:8,skewY:188,y:146.9},0).wait(36).to({skewX:7.8,skewY:187.8,x:514.4},0).wait(4).to({skewX:8,skewY:188,x:514.5},0).wait(2).to({regX:31.2,regY:0.8,skewX:5.3,skewY:185.3,x:514.4,y:147},0).wait(2).to({regX:31.1,regY:2,skewX:2.5,skewY:182.5,x:514.5,y:148},0).wait(2).to({regX:31.2,regY:1.9,skewX:0,skewY:180,y:148.5},0).wait(168));

	// Iguana Upper Leg
	this.instance_7 = new lib.IguanaUpperLeg_1();
	this.instance_7.parent = this;
	this.instance_7.setTransform(526,148.1,0.412,0.412,0,0,180,1.6,5);

	this.timeline.addTween(cjs.Tween.get(this.instance_7).wait(4).to({scaleX:0.42,skewY:183.8,y:148},0).wait(2).to({scaleX:0.42,skewY:187.5,y:147.9},0).wait(2).to({scaleX:0.42,skewY:191.4,y:147.8},0).wait(8).to({scaleX:0.42,skewY:187.5,y:147.9},0).wait(2).to({scaleX:0.42,skewY:183.8,y:148},0).wait(2).to({scaleX:0.41,skewY:180,y:148.1},0).wait(60).to({skewX:-2.8,skewY:177.2,y:147.4},0).wait(2).to({regX:2,regY:4,skewX:-5.8,skewY:174.2,x:525.7,y:146.4},0).wait(2).to({regX:1.6,regY:4.8,skewX:-8.8,skewY:171.2,x:525.9,y:146.1},0).wait(2).to({regX:1.9,regY:4.9,skewX:-11.7,skewY:168.3,y:145.4},0).wait(2).to({regX:2,skewX:-11.6,skewY:168.4},0).wait(30).to({regX:1.9,skewX:-11.7,skewY:168.3},0).wait(2).to({regY:5,skewX:-9,skewY:171,x:526,y:146},0).wait(2).to({regX:1.7,regY:5.1,skewX:-6.3,skewY:173.7,x:526.2,y:146.7},0).wait(2).to({regY:5,skewX:-3.5,skewY:176.5,y:147.3},0).wait(2).to({regX:-0.1,regY:4.9,skewX:-0.8,skewY:179.2,x:526.9,y:147.8},0).wait(2).to({regX:1.6,regY:5,skewX:1.7,skewY:181.7,x:526.2,y:148.5},0).wait(2).to({regX:1.5,skewX:1,skewY:181,x:526.1,y:148.4},0).wait(2).to({regX:1.4,skewX:0.5,skewY:180.5,y:148.2},0).wait(2).to({regX:1.6,skewX:0,skewY:180,x:526,y:148.1},0).wait(48).to({scaleX:0.42,skewY:183.8,y:148},0).wait(2).to({scaleX:0.42,skewY:187.5,y:147.9},0).wait(2).to({scaleX:0.42,skewY:191.4,y:147.8},0).wait(4).to({scaleX:0.41,skewY:180,y:148.1},0).wait(2).to({skewX:-4.3,skewY:175.7,x:525.6,y:146.4},0).wait(2).to({skewX:-8.5,skewY:171.5,x:525.3,y:144.6},0).wait(36).to({y:144.7},0).wait(4).to({y:144.6},0).wait(2).to({skewX:-5.6,skewY:174.4,x:525.6,y:145.7},0).wait(2).to({regX:1.7,skewX:-2.8,skewY:177.2,x:525.7,y:146.9},0).wait(2).to({regX:1.6,skewX:0,skewY:180,x:526,y:148.1},0).wait(168));

	// Iguana Hand
	this.instance_8 = new lib.IguanaHand_1();
	this.instance_8.parent = this;
	this.instance_8.setTransform(499.2,155.4,0.412,0.412,0,0,180,3.1,4.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_8).wait(408));

	// Iguana Lower arm
	this.iguana_frontleg = new lib.IguanaLowerarm();
	this.iguana_frontleg.parent = this;
	this.iguana_frontleg.setTransform(500.5,148.7,0.412,0.412,0,0,180,5.5,3.8);

	this.timeline.addTween(cjs.Tween.get(this.iguana_frontleg).wait(4).to({skewX:12.3,skewY:192.3,x:501.5,y:149.7},0).wait(2).to({regY:3.7,skewX:24.8,skewY:204.8,x:502.5,y:150.6},0).wait(2).to({regY:4,skewX:37.2,skewY:217.2,x:503.5,y:151.6},0).wait(8).to({regY:3.7,skewX:24.8,skewY:204.8,x:502.5,y:150.6},0).wait(2).to({regY:3.8,skewX:12.3,skewY:192.3,x:501.5,y:149.7},0).wait(2).to({skewX:0,skewY:180,x:500.5,y:148.7},0).wait(60).to({skewX:-2.3,skewY:177.7,x:500.2,y:148.6},0).wait(2).to({skewX:-4.8,skewY:175.2,x:500,y:148.5},0).wait(2).to({regX:5.4,regY:3.9,skewX:-7.3,skewY:172.7,x:499.6,y:148.4},0).wait(2).to({regX:5.5,regY:3.8,skewX:-9.7,skewY:170.3,x:499.3,y:148.3},0).wait(2).to({regX:5.6,regY:3.7,skewX:-9.6,skewY:170.4,x:499.4},0).wait(30).to({regX:5.5,regY:3.8,skewX:-9.7,skewY:170.3,x:499.3},0).wait(2).to({skewX:-6.8,skewY:173.2,x:499.8,y:148.5},0).wait(2).to({regX:5.4,regY:3.6,skewX:-4,skewY:176,x:500.3},0).wait(2).to({regX:5,regY:3.7,skewX:-1.1,skewY:178.9,x:500.9,y:148.8},0).wait(2).to({regX:5.5,regY:3.6,skewX:1.5,skewY:181.5,x:501.1,y:148.9},0).wait(2).to({regX:5.3,regY:3.7,skewX:4.5,skewY:184.5,x:501.5,y:149.1},0).wait(2).to({regX:5.4,regY:3.8,skewX:2.8,skewY:182.8,x:501.1,y:148.9},0).wait(2).to({skewX:1.3,skewY:181.3,x:500.8,y:148.8},0).wait(2).to({regX:5.5,skewX:0,skewY:180,x:500.5,y:148.7},0).wait(48).to({skewX:12.3,skewY:192.3,x:501.5,y:149.7},0).wait(2).to({regY:3.7,skewX:24.8,skewY:204.8,x:502.5,y:150.6},0).wait(2).to({regY:4,skewX:37.2,skewY:217.2,x:503.5,y:151.6},0).wait(4).to({regY:3.8,skewX:0,skewY:180,x:500.5,y:148.7},0).wait(2).to({regX:5.7,regY:3.7,scaleX:0.43,scaleY:0.48,skewX:-0.5,skewY:173.5,x:500.4,y:147.1},0).wait(2).to({regX:5.4,regY:3.9,scaleX:0.44,scaleY:0.54,skewX:-1.1,skewY:166.8,x:500.3,y:145.6},0).wait(6).to({regX:5.5,scaleX:0.44,scaleY:0.54,skewX:-3.5,skewY:166.7,x:499.9},0).wait(2).to({regX:5.4,regY:4,scaleX:0.44,scaleY:0.54,skewX:-5.8,x:499.3},0).wait(2).to({regY:3.9,scaleX:0.43,scaleY:0.54,skewX:-8.3,skewY:166.4,x:498.9},0).wait(2).to({regX:5.3,scaleX:0.44,scaleY:0.54,skewX:-4.6,skewY:166.7,x:499.7},0).wait(2).to({regX:5.4,scaleX:0.44,scaleY:0.54,skewX:-1.1,skewY:166.8,x:500.3},0).wait(2).to({regY:3.8,scaleX:0.44,scaleY:0.54,skewX:-2.8,skewY:166.7,x:500},0).wait(2).to({regX:5.2,regY:4,scaleX:0.44,scaleY:0.54,skewX:-4.6,x:499.7},0).wait(2).to({regX:5.5,regY:4.2,scaleX:0.43,scaleY:0.54,skewX:-6.3,x:499.3,y:145.7},0).wait(2).to({regX:5.4,regY:3.9,scaleX:0.43,scaleY:0.54,skewX:-8.3,skewY:166.4,x:498.9,y:145.6},0).wait(2).to({scaleX:0.44,scaleY:0.54,skewX:-5.8,skewY:166.7,x:499.4},0).wait(2).to({regY:4,scaleX:0.44,scaleY:0.54,skewX:-3.5,x:499.9},0).wait(2).to({regY:3.9,scaleX:0.44,scaleY:0.54,skewX:-1.1,skewY:166.8,x:500.3},0).wait(2).to({regX:5.5,scaleX:0.44,scaleY:0.54,skewX:-3.5,skewY:166.7,x:499.9},0).wait(2).to({regX:5.4,regY:4,scaleX:0.44,scaleY:0.54,skewX:-5.8,x:499.3},0).wait(2).to({regY:3.9,scaleX:0.43,scaleY:0.54,skewX:-8.3,skewY:166.4,x:498.9},0).wait(2).to({scaleX:0.44,scaleY:0.54,skewX:-5.8,skewY:166.7,x:499.4},0).wait(2).to({regY:4,scaleX:0.44,scaleY:0.54,skewX:-3.5,x:499.9},0).wait(2).to({regY:3.9,scaleX:0.44,scaleY:0.54,skewX:-1.1,skewY:166.8,x:500.3},0).wait(2).to({regX:5.5,scaleX:0.43,scaleY:0.5,skewX:-0.8,skewY:171.2,x:500.4,y:146.6},0).wait(2).to({regY:3.8,scaleX:0.42,scaleY:0.45,skewX:-0.3,skewY:175.7,x:500.5,y:147.6},0).wait(2).to({scaleX:0.41,scaleY:0.41,skewX:0,skewY:180,y:148.7},0).wait(168));

	// Iguana Upper Arm
	this.instance_9 = new lib.IguanaUpperArm_1();
	this.instance_9.parent = this;
	this.instance_9.setTransform(496.5,137.4,0.412,0.412,0,0,180,12.8,3.4);

	this.timeline.addTween(cjs.Tween.get(this.instance_9).wait(4).to({regX:12.7,regY:3.3,scaleY:0.42,skewX:1,skewY:179.2,x:497.6,y:138},0).wait(2).to({regX:12.8,regY:3.5,scaleY:0.42,skewX:2.3,skewY:178.5,x:498.7,y:138.6},0).wait(2).to({regY:3.6,scaleY:0.43,skewX:3.5,skewY:177.5,x:499.8,y:139.2},0).wait(8).to({regY:3.5,scaleY:0.42,skewX:2.3,skewY:178.5,x:498.7,y:138.6},0).wait(2).to({regX:12.7,regY:3.3,scaleY:0.42,skewX:1,skewY:179.2,x:497.6,y:138},0).wait(2).to({regX:12.8,regY:3.4,scaleY:0.41,skewX:0,skewY:180,x:496.5,y:137.4},0).wait(60).to({regX:12.1,regY:3.3,skewX:3,skewY:183,x:497.1,y:137},0).wait(2).to({regX:12.7,regY:3.4,skewX:6,skewY:186,x:497.2,y:136.5},0).wait(2).to({regX:12.8,regY:3.1,skewX:9,skewY:189,x:497.5,y:136},0).wait(2).to({regX:12.7,regY:3.6,skewX:12.2,skewY:192.2,x:497.8,y:135.7},0).wait(2).to({skewX:12.1,skewY:192.1,y:135.6},0).wait(30).to({skewX:12.2,skewY:192.2,y:135.7},0).wait(2).to({regX:12.6,skewX:8.5,skewY:188.5,x:497.6,y:136.1},0).wait(2).to({regX:10.8,regY:3.2,skewX:4.8,skewY:184.8,x:498.1,y:136.5},0).wait(2).to({regX:12.8,regY:3.6,skewX:1.1,skewY:181.1,x:497,y:137},0).wait(2).to({regX:12.7,skewX:-2.3,skewY:177.7,x:496.7,y:137.4},0).wait(2).to({regX:12.8,regY:3,skewX:-6.1,skewY:173.9,x:496.5,y:137.9},0).wait(2).to({skewX:-4,skewY:176,y:137.7},0).wait(2).to({regX:12.7,skewX:-2,skewY:178,y:137.6},0).wait(2).to({regX:12.8,regY:3.4,skewX:0,skewY:180,y:137.4},0).wait(48).to({regX:12.7,regY:3.3,scaleY:0.42,skewX:1,skewY:179.2,x:497.6,y:138},0).wait(2).to({regX:12.8,regY:3.5,scaleY:0.42,skewX:2.3,skewY:178.5,x:498.7,y:138.6},0).wait(2).to({regY:3.6,scaleY:0.43,skewX:3.5,skewY:177.5,x:499.8,y:139.2},0).wait(4).to({regY:3.4,scaleY:0.41,skewX:0,skewY:180,x:496.5,y:137.4},0).wait(2).to({regY:3.5,scaleX:0.4,scaleY:0.5,skewX:7.8,skewY:185.8,x:498.5,y:133.9},0).wait(2).to({regX:12.6,regY:3.6,scaleX:0.39,scaleY:0.6,skewX:15.8,skewY:191.6,x:500.5,y:130.3},0).wait(6).to({regX:12.7,regY:3.8,scaleX:0.4,scaleY:0.59,skewX:13.3,skewY:191.5,x:499.4,y:130.4},0).wait(2).to({regX:12.6,regY:3.6,scaleX:0.4,scaleY:0.59,skewX:11.1,skewY:191.3,x:498.3,y:130.2},0).wait(2).to({scaleX:0.4,scaleY:0.58,skewX:8.9,x:497.3,y:130.3},0).wait(2).to({regX:12.5,regY:3.9,scaleX:0.4,scaleY:0.59,skewX:12.3,x:498.8,y:130.5},0).wait(2).to({regX:12.6,regY:3.6,scaleX:0.39,scaleY:0.6,skewX:15.8,skewY:191.6,x:500.5,y:130.3},0).wait(2).to({scaleX:0.4,scaleY:0.59,skewX:14,skewY:191.5,x:499.7},0).wait(2).to({regX:12.7,regY:3.8,scaleX:0.4,scaleY:0.59,skewX:12.3,skewY:191.3,x:498.8,y:130.4},0).wait(2).to({regX:13.2,regY:3.4,scaleX:0.4,scaleY:0.59,skewX:10.5,x:497.8,y:130.1},0).wait(2).to({regX:12.6,regY:3.6,scaleX:0.4,scaleY:0.58,skewX:8.9,x:497.3,y:130.3},0).wait(2).to({regX:12.3,scaleX:0.4,scaleY:0.59,skewX:11.1,x:498.4},0).wait(2).to({regX:12.6,scaleX:0.4,scaleY:0.59,skewX:13.3,skewY:191.5,x:499.4},0).wait(2).to({scaleX:0.39,scaleY:0.6,skewX:15.8,skewY:191.6,x:500.5},0).wait(2).to({regX:12.7,regY:3.8,scaleX:0.4,scaleY:0.59,skewX:13.3,skewY:191.5,x:499.4,y:130.4},0).wait(2).to({regX:12.6,regY:3.6,scaleX:0.4,scaleY:0.59,skewX:11.1,skewY:191.3,x:498.3,y:130.2},0).wait(2).to({scaleX:0.4,scaleY:0.58,skewX:8.9,x:497.3,y:130.3},0).wait(2).to({regX:12.3,scaleX:0.4,scaleY:0.59,skewX:11.1,x:498.4},0).wait(2).to({regX:12.6,scaleX:0.4,scaleY:0.59,skewX:13.3,skewY:191.5,x:499.4},0).wait(2).to({scaleX:0.39,scaleY:0.6,skewX:15.8,skewY:191.6,x:500.5},0).wait(2).to({regX:12.7,scaleX:0.4,scaleY:0.54,skewX:10.5,skewY:187.6,x:499.2,y:132.6},0).wait(2).to({regX:12.6,regY:3.7,scaleX:0.41,scaleY:0.47,skewX:5.3,skewY:183.8,x:497.9,y:135},0).wait(2).to({regX:12.8,regY:3.4,scaleX:0.41,scaleY:0.41,skewX:0,skewY:180,x:496.5,y:137.4},0).wait(168));

	// Iguana Tail
	this.iguana_tail = new lib.IguanaTail();
	this.iguana_tail.parent = this;
	this.iguana_tail.setTransform(531.5,146.9,0.412,0.412,0,0,180,140.2,8.1);

	this.timeline.addTween(cjs.Tween.get(this.iguana_tail).wait(4).to({x:531.7,y:146.6},0).wait(2).to({regY:8.2,x:531.9,y:146.3},0).wait(2).to({x:532.1,y:146},0).wait(8).to({x:531.9,y:146.3},0).wait(2).to({regY:8.1,x:531.7,y:146.6},0).wait(2).to({x:531.5,y:146.9},0).wait(60).to({regX:140.1,regY:8.3,skewX:0.8,skewY:180.8,y:146.4},0).wait(2).to({regX:140,regY:8.6,skewX:1.8,skewY:181.8,x:531.6,y:145.9},0).wait(2).to({regX:140.2,regY:8.2,skewX:2.8,skewY:182.8,x:531.5,y:145.1},0).wait(2).to({skewX:3.9,skewY:183.9,y:144.5},0).wait(2).to({regX:139.7,skewX:3.8,skewY:183.8,x:531.7},0).wait(30).to({regX:140.2,skewX:3.9,skewY:183.9,x:531.5},0).wait(2).to({regX:139.8,skewX:2.8,skewY:182.8,x:531.7,y:145},0).wait(2).to({regX:140,skewX:1.8,skewY:181.8,x:531.6,y:145.5},0).wait(2).to({regX:140.1,regY:6.2,skewX:0.8,skewY:180.8,y:145.2},0).wait(2).to({regX:140.2,regY:8.2,skewX:0,skewY:180,y:146.6},0).wait(2).to({regX:140,skewX:-1.2,skewY:178.8,y:147.1},0).wait(2).to({regX:139.8,regY:8.1,skewX:-0.8,skewY:179.2,y:147},0).wait(2).to({regX:140.1,regY:8.2,skewX:-0.3,skewY:179.7,x:531.5},0).wait(2).to({regX:140.2,regY:8.1,skewX:0,skewY:180,y:146.9},0).wait(48).to({x:531.7,y:146.6},0).wait(2).to({regY:8.2,x:531.9,y:146.3},0).wait(2).to({x:532.1,y:146},0).wait(4).to({regY:8.1,x:531.5,y:146.9},0).wait(2).to({regX:139.8,regY:8.4,scaleX:0.42,skewX:4.6,skewY:183.5,x:530.8,y:145.6},0).wait(2).to({regX:140.2,regY:8.2,scaleX:0.43,skewX:9.4,skewY:187,x:529.7,y:144.1},0).wait(36).to({skewX:9.3},0).wait(4).to({skewX:9.4},0).wait(2).to({regX:140.3,scaleX:0.43,skewX:6.3,skewY:184.5,x:530.3,y:145.1},0).wait(2).to({regX:140.2,regY:7.6,scaleX:0.42,skewX:3,skewY:182.3,x:531,y:145.7},0).wait(2).to({regY:8.1,scaleX:0.41,skewX:0,skewY:180,x:531.5,y:146.9},0).wait(168));

	// Iguana Torso
	this.iguana_torso = new lib.IguanaTorso();
	this.iguana_torso.parent = this;
	this.iguana_torso.setTransform(522.2,147.8,0.412,0.412,0,-7.1,172.9,30.2,59.2);

	this.timeline.addTween(cjs.Tween.get(this.iguana_torso).wait(4).to({regY:59.5,scaleX:0.42,scaleY:0.41,skewX:-4.3,skewY:171},0).wait(2).to({regX:35.6,regY:59.6,scaleX:0.42,scaleY:0.42,skewX:-1.3,skewY:168.9,x:520,y:148.3},0).wait(2).to({regX:30.3,regY:59.4,scaleX:0.42,scaleY:0.42,skewX:1.3,skewY:166.8,x:522.2,y:147.8},0).wait(8).to({regX:35.6,regY:59.6,scaleX:0.42,scaleY:0.42,skewX:-1.3,skewY:168.9,x:520,y:148.3},0).wait(2).to({regX:30.2,regY:59.5,scaleX:0.42,scaleY:0.41,skewX:-4.3,skewY:171,x:522.2,y:147.8},0).wait(2).to({regY:59.2,scaleX:0.41,scaleY:0.41,skewX:-7.1,skewY:172.9},0).wait(60).to({regX:30.1,skewX:-7,skewY:173,x:522.3,y:147.1},0).wait(2).to({regX:30.2,x:522.2,y:146.5},0).wait(2).to({regX:30.1,x:522.3,y:145.9},0).wait(2).to({regX:30.2,skewX:-7.1,skewY:172.9,x:522.2,y:145.4},0).wait(2).to({skewX:-7,skewY:173},0).wait(30).to({skewX:-7.1,skewY:172.9},0).wait(2).to({regX:29.9,regY:58.4,skewX:-7.3,skewY:172.7,x:522.3,y:145.5},0).wait(2).to({regX:30.2,regY:59.3,skewX:-7.5,skewY:172.5,x:522.2,y:146.5},0).wait(2).to({regX:29.9,regY:59.2,skewX:-7.8,skewY:172.2,x:522.3,y:147},0).wait(2).to({regX:30.3,regY:59.1,skewX:-8,skewY:172,y:147.6},0).wait(2).to({regX:30.2,regY:59.2,skewX:-8.3,skewY:171.7,y:148.1},0).wait(2).to({regX:30.4,regY:59.5,skewX:-7.8,skewY:172.2,x:522.2},0).wait(2).to({regX:30.2,regY:59.2,skewX:-7.3,skewY:172.7,x:522.3,y:147.9},0).wait(2).to({skewX:-7.1,skewY:172.9,x:522.2,y:147.8},0).wait(48).to({regY:59.5,scaleX:0.42,scaleY:0.41,skewX:-4.3,skewY:171},0).wait(2).to({regX:35.6,regY:59.6,scaleX:0.42,scaleY:0.42,skewX:-1.3,skewY:168.9,x:520,y:148.3},0).wait(2).to({regX:30.3,regY:59.4,scaleX:0.42,scaleY:0.42,skewX:1.3,skewY:166.8,x:522.2,y:147.8},0).wait(4).to({regX:30.2,regY:59.2,scaleX:0.41,scaleY:0.41,skewX:-7.1,skewY:172.9},0).wait(2).to({scaleX:0.41,skewX:-0.3,skewY:175.5,x:521.1,y:146.1},0).wait(2).to({regX:30.1,regY:59.5,scaleX:0.42,scaleY:0.41,skewX:6.2,skewY:177.8,x:520,y:144.4},0).wait(2).to({regX:30,regY:59.6,skewX:6.1,skewY:177.9},0).wait(2).to({regX:30.1,regY:59.5,skewX:6.2,skewY:177.8},0).wait(2).to({regX:30.2,scaleY:0.41,skewX:4,skewY:177.9},0).wait(2).to({regX:30.1,regY:59.6,scaleY:0.41,skewX:2},0).wait(2).to({regX:30.2,regY:59.5,scaleY:0.41,skewX:0.2,skewY:177.8},0).wait(2).to({scaleY:0.41,skewX:3,skewY:177.9},0).wait(2).to({regX:30.1,scaleY:0.41,skewX:6.2,skewY:177.8},0).wait(2).to({scaleY:0.41,skewX:4.5,skewY:177.9},0).wait(2).to({regY:59.6,scaleY:0.41,skewX:3},0).wait(2).to({regY:59.5,scaleY:0.41,skewX:1.5},0).wait(2).to({regX:30.2,scaleY:0.41,skewX:0.2,skewY:177.8},0).wait(2).to({regX:30.1,regY:59.6,scaleY:0.41,skewX:2,skewY:177.9,x:520.1},0).wait(2).to({regX:30.2,regY:59.5,scaleY:0.41,skewX:4,x:520},0).wait(2).to({regX:30.1,scaleY:0.41,skewX:6.2,skewY:177.8},0).wait(2).to({regX:30.2,scaleY:0.41,skewX:4,skewY:177.9},0).wait(2).to({regX:30.1,regY:59.6,scaleY:0.41,skewX:2},0).wait(2).to({regX:30.2,regY:59.5,scaleY:0.41,skewX:0.2,skewY:177.8},0).wait(2).to({regX:30.1,regY:59.6,scaleY:0.41,skewX:2,skewY:177.9,x:520.1},0).wait(2).to({regX:30.2,regY:59.5,scaleY:0.41,skewX:4,x:520},0).wait(2).to({regX:30.1,scaleY:0.41,skewX:6.2,skewY:177.8},0).wait(2).to({regX:30.2,regY:57.6,scaleX:0.41,scaleY:0.41,skewX:1.8,skewY:176.2,x:520.7,y:144.8},0).wait(2).to({regX:30.1,regY:59.6,scaleX:0.41,skewX:-2.5,skewY:174.7,x:521.5,y:146.7},0).wait(2).to({regX:30.2,regY:59.2,scaleX:0.41,skewX:-7.1,skewY:172.9,x:522.2,y:147.8},0).wait(168));

	// Iguana Neck
	this.iguana_neck = new lib.IguanaNeck();
	this.iguana_neck.parent = this;
	this.iguana_neck.setTransform(496.6,129.6,0.412,0.412,0,0,180,11.7,32.5);

	this.timeline.addTween(cjs.Tween.get(this.iguana_neck).wait(4).to({regX:11.6,regY:32.6,scaleX:0.41,scaleY:0.41,skewX:3,skewY:175.5,x:497.6,y:130.3},0).wait(2).to({regY:32.5,scaleX:0.41,scaleY:0.41,skewX:6.3,skewY:170.7,x:498.6,y:131},0).wait(2).to({regX:11.4,regY:32.8,scaleX:0.41,scaleY:0.41,skewX:9.5,skewY:166,x:499.6,y:131.8},0).wait(8).to({regX:11.6,regY:32.5,scaleX:0.41,scaleY:0.41,skewX:6.3,skewY:170.7,x:498.6,y:131},0).wait(2).to({regY:32.6,scaleX:0.41,scaleY:0.41,skewX:3,skewY:175.5,x:497.6,y:130.3},0).wait(2).to({regX:11.7,regY:32.5,scaleX:0.41,scaleY:0.41,skewX:0,skewY:180,x:496.6,y:129.6},0).wait(60).to({regX:11.6,regY:32.6,skewX:-3,skewY:177,x:496.5,y:129},0).wait(2).to({regY:32.5,skewX:-6,skewY:174,y:128.4},0).wait(2).to({regY:32.8,skewX:-9,skewY:171,x:496.4,y:127.9},0).wait(2).to({regX:11.8,regY:32.3,skewX:-12.2,skewY:167.8,x:496.3,y:127.3},0).wait(2).to({regY:32.1,skewX:-12.1,skewY:167.9,x:496.2,y:127.2},0).wait(30).to({regY:32.3,skewX:-12.2,skewY:167.8,x:496.3,y:127.3},0).wait(2).to({regY:32.4,skewX:-9.6,skewY:170.4,y:127.8},0).wait(2).to({regY:31.2,skewX:-7.3,skewY:172.7,x:496.4,y:127.9},0).wait(2).to({regY:32.3,skewX:-4.8,skewY:175.2,y:128.9},0).wait(2).to({regY:32.4,skewX:-2.3,skewY:177.7,x:496.6,y:129.5},0).wait(2).to({regX:11.7,regY:32.5,skewX:0,skewY:180,y:130.1},0).wait(2).to({y:129.9},0).wait(2).to({y:129.7},0).wait(2).to({y:129.6},0).wait(48).to({regX:11.6,regY:32.6,scaleX:0.41,scaleY:0.41,skewX:3,skewY:175.5,x:497.6,y:130.3},0).wait(2).to({regY:32.5,scaleX:0.41,scaleY:0.41,skewX:6.3,skewY:170.7,x:498.6,y:131},0).wait(2).to({regX:11.4,regY:32.8,scaleX:0.41,scaleY:0.41,skewX:9.5,skewY:166,x:499.6,y:131.8},0).wait(4).to({regX:11.7,regY:32.5,scaleX:0.41,scaleY:0.41,skewX:0,skewY:180,x:496.6,y:129.6},0).wait(2).to({regX:11.6,regY:32.4,scaleX:0.41,scaleY:0.42,skewX:-1.5,skewY:172.5,x:498,y:127.4},0).wait(2).to({regX:11.1,regY:32.6,scaleX:0.4,scaleY:0.42,skewX:-3,skewY:165,x:499.4,y:125.3},0).wait(2).to({scaleX:0.4},0).wait(2).to({scaleX:0.4},0).wait(2).to({regX:11.2,scaleX:0.4,scaleY:0.42,skewX:-23.3,skewY:144.6,x:498.7,y:125.6},0).wait(2).to({regY:32.7,skewX:-35.6,skewY:132.4,x:498.3,y:125.8},0).wait(2).to({regX:11.3,regY:32.9,scaleX:0.4,scaleY:0.42,skewX:-39.8,skewY:128.2,x:498.1},0).wait(2).to({regX:11.2,regY:32.8,scaleX:0.4,scaleY:0.42,skewX:-21.3,skewY:146.7,x:498.8,y:125.5},0).wait(2).to({regX:11.1,regY:32.6,scaleX:0.4,scaleY:0.42,skewX:-3,skewY:165,x:499.4,y:125.3},0).wait(2).to({regX:11.2,regY:32.8,scaleX:0.4,scaleY:0.42,skewX:-12.1,skewY:155.9,x:499.3,y:125.4},0).wait(2).to({regX:11.1,regY:32.7,skewX:-21.3,skewY:146.7},0).wait(2).to({regX:11.2,skewX:-30.6,skewY:137.4},0).wait(2).to({regX:11.3,regY:32.9,scaleX:0.4,scaleY:0.42,skewX:-39.8,skewY:128.2},0).wait(2).to({regX:11.2,regY:32.8,scaleX:0.4,scaleY:0.42,skewX:-27.5,skewY:140.4,x:499.4,y:125.3},0).wait(2).to({regY:33,skewX:-15.3,skewY:152.7,y:125.4},0).wait(2).to({regX:11.1,regY:32.6,scaleX:0.4,scaleY:0.42,skewX:-3,skewY:165,y:125.3},0).wait(2).to({regY:32.8,scaleX:0.4,scaleY:0.42,skewX:-15.3,skewY:152.7,y:125.5},0).wait(2).to({regX:11.2,regY:32.6,skewX:-27.5,skewY:140.4,x:499.3,y:125.4},0).wait(2).to({regX:11.3,regY:32.9,scaleX:0.4,scaleY:0.42,skewX:-39.8,skewY:128.2},0).wait(2).to({regX:11.2,regY:32.8,scaleX:0.4,scaleY:0.42,skewX:-27.5,skewY:140.4,x:499.4,y:125.3},0).wait(2).to({regY:33,skewX:-15.3,skewY:152.7,y:125.4},0).wait(2).to({regX:11.1,regY:32.6,scaleX:0.4,scaleY:0.42,skewX:-3,skewY:165,y:125.3},0).wait(2).to({regX:9.1,regY:32.8,scaleX:0.41,scaleY:0.42,skewX:-2,skewY:170,x:499.3,y:126.7},0).wait(2).to({regX:11.2,regY:32.6,scaleX:0.41,scaleY:0.41,skewX:-1,skewY:175,x:497.5,y:128.2},0).wait(2).to({regX:11.7,regY:32.5,scaleX:0.41,scaleY:0.41,skewX:0,skewY:180,x:496.6,y:129.6},0).wait(168));

	// Iguana Hind Back Foot
	this.instance_10 = new lib.IguanaHindBackFoot_1();
	this.instance_10.parent = this;
	this.instance_10.setTransform(524.8,154.8,1.093,1.093,0,0,0,14.2,1.6);

	this.timeline.addTween(cjs.Tween.get(this.instance_10).wait(408));

	// Iguana Hind Back Lower Leg
	this.instance_11 = new lib.IguanaHindBackLowerLeg_1();
	this.instance_11.parent = this;
	this.instance_11.setTransform(513.3,147.4,0.412,0.412,0,0,180,30.1,1.7);

	this.timeline.addTween(cjs.Tween.get(this.instance_11).wait(408));

	// Iguana Hind Back Upper Leg
	this.instance_12 = new lib.IguanaHindBackUpperLeg_1();
	this.instance_12.parent = this;
	this.instance_12.setTransform(524,146.7,0.412,0.412,0,0,180,3,5.1);

	this.timeline.addTween(cjs.Tween.get(this.instance_12).wait(408));

	// Iguana Front Back Lower Leg
	this.iguana_frontlegback = new lib.IguanaFrontBackLowerLeg();
	this.iguana_frontlegback.parent = this;
	this.iguana_frontlegback.setTransform(498.2,146.1,0.412,0.412,0,0,180,6.5,1.9);

	this.timeline.addTween(cjs.Tween.get(this.iguana_frontlegback).wait(4).to({scaleX:0.46,scaleY:0.39,skewX:4.8,skewY:184.8,x:499,y:147},0).wait(2).to({regX:5.7,regY:1.6,scaleX:0.5,scaleY:0.37,skewX:9.8,skewY:189.8,x:500.2,y:147.8},0).wait(2).to({regX:6.8,regY:1.4,scaleX:0.54,scaleY:0.35,skewX:14.9,skewY:194.9,x:500.6,y:148.7},0).wait(8).to({regX:5.7,regY:1.6,scaleX:0.5,scaleY:0.37,skewX:9.8,skewY:189.8,x:500.2,y:147.8},0).wait(2).to({regX:6.5,regY:1.9,scaleX:0.46,scaleY:0.39,skewX:4.8,skewY:184.8,x:499,y:147},0).wait(2).to({scaleX:0.41,scaleY:0.41,skewX:0,skewY:180,x:498.2,y:146.1},0).wait(60).to({regY:2.1,scaleX:0.41,scaleY:0.41,skewX:-1.3,skewY:178,x:498},0).wait(2).to({regY:2,scaleX:0.41,scaleY:0.42,skewX:-2.5,skewY:175.7,x:498.1,y:146},0).wait(2).to({scaleY:0.42,skewX:-3.8,skewY:173.7,x:498},0).wait(2).to({regX:6.4,regY:1.9,scaleX:0.42,scaleY:0.42,skewX:-5.3,skewY:171.4,x:497.9},0).wait(2).to({regX:6.5,regY:1.8,skewY:171.5,y:145.9},0).wait(30).to({regX:6.4,regY:1.9,skewY:171.4,y:146},0).wait(2).to({scaleY:0.42,skewX:-3.5,skewY:173.9,x:498.1,y:146.1},0).wait(2).to({regX:6.3,regY:-0.1,scaleX:0.41,scaleY:0.42,skewX:-1.8,skewY:176.2,x:498.3,y:145.3},0).wait(2).to({regX:6.4,regY:1.9,scaleX:0.41,scaleY:0.41,skewX:0,skewY:178.7,x:498.5,y:146.3},0).wait(2).to({regX:6.5,regY:1.8,scaleY:0.41,skewX:1.5,skewY:180.8},0).wait(2).to({regY:1.9,scaleX:0.41,scaleY:0.41,skewX:3.2,skewY:183.2,x:498.8,y:146.5},0).wait(2).to({regX:6.6,skewX:2,skewY:182,x:498.6,y:146.3},0).wait(2).to({regX:6.2,skewX:1,skewY:181,x:498.5},0).wait(2).to({regX:6.5,skewX:0,skewY:180,x:498.2,y:146.1},0).wait(48).to({scaleX:0.46,scaleY:0.39,skewX:4.8,skewY:184.8,x:499,y:147},0).wait(2).to({regX:5.7,regY:1.6,scaleX:0.5,scaleY:0.37,skewX:9.8,skewY:189.8,x:500.2,y:147.8},0).wait(2).to({regX:6.8,regY:1.4,scaleX:0.54,scaleY:0.35,skewX:14.9,skewY:194.9,x:500.6,y:148.7},0).wait(4).to({regX:6.5,regY:1.9,scaleX:0.41,scaleY:0.41,skewX:0,skewY:180,x:498.2,y:146.1},0).wait(2).to({scaleY:0.5,skewX:0.1,x:498.7,y:144.2},0).wait(2).to({regX:6.7,scaleY:0.58,skewX:0.5,x:499.3,y:142.4},0).wait(6).to({regX:4.8,scaleY:0.58,skewX:-1.8,x:499.5},0).wait(2).to({regX:6.7,scaleY:0.58,skewX:-4.3,x:498.2},0).wait(2).to({regX:6.2,scaleY:0.59,skewX:-6.7,x:497.7},0).wait(2).to({scaleY:0.58,skewX:-3,x:498.5,y:142.3},0).wait(2).to({regX:6.7,scaleY:0.58,skewX:0.5,x:499.3,y:142.4},0).wait(2).to({regX:6.9,scaleY:0.58,skewX:-1.3,x:498.8},0).wait(2).to({regX:6.7,scaleY:0.58,skewX:-3,x:498.5,y:142.3},0).wait(2).to({scaleY:0.58,skewX:-4.8,x:498,y:142.4},0).wait(2).to({regX:6.2,scaleY:0.59,skewX:-6.7,x:497.7},0).wait(2).to({regX:6.3,scaleY:0.58,skewX:-4.3,x:498.2},0).wait(2).to({regX:6.2,scaleY:0.58,skewX:-1.8,x:498.8},0).wait(2).to({regX:6.7,scaleY:0.58,skewX:0.5,x:499.3},0).wait(2).to({regX:4.8,scaleY:0.58,skewX:-1.8,x:499.5},0).wait(2).to({regX:6.7,scaleY:0.58,skewX:-4.3,x:498.2},0).wait(2).to({regX:6.2,scaleY:0.59,skewX:-6.7,x:497.7},0).wait(2).to({regX:6.3,scaleY:0.58,skewX:-4.3,x:498.2},0).wait(2).to({regX:6.2,scaleY:0.58,skewX:-1.8,x:498.8},0).wait(2).to({regX:6.7,scaleY:0.58,skewX:0.5,x:499.3},0).wait(2).to({regY:1.8,scaleY:0.53,skewX:0.3,x:498.9,y:143.6},0).wait(2).to({regX:6.5,regY:1.9,scaleY:0.47,skewX:0,x:498.6,y:144.8},0).wait(2).to({scaleY:0.41,x:498.2,y:146.1},0).wait(168));

	// Iguana Front Back Upper Leg
	this.instance_13 = new lib.IguanaFrontBackUpperLeg_1();
	this.instance_13.parent = this;
	this.instance_13.setTransform(496.3,138.2,0.412,0.412,0,0,180,8.6,7);

	this.timeline.addTween(cjs.Tween.get(this.instance_13).wait(4).to({regX:8.1,regY:6.8,scaleX:0.46,scaleY:0.39,skewX:4.8,skewY:184.8,x:497.8,y:139.4},0).wait(2).to({regX:8.6,regY:7,scaleX:0.5,scaleY:0.37,skewX:9.8,skewY:189.8,x:498.7,y:140.6},0).wait(2).to({regX:8.8,regY:6.9,scaleX:0.54,scaleY:0.35,skewX:14.9,skewY:194.9,x:500,y:141.8},0).wait(8).to({regX:8.6,regY:7,scaleX:0.5,scaleY:0.37,skewX:9.8,skewY:189.8,x:498.7,y:140.6},0).wait(2).to({regX:8.1,regY:6.8,scaleX:0.46,scaleY:0.39,skewX:4.8,skewY:184.8,x:497.8,y:139.4},0).wait(2).to({regX:8.6,regY:7,scaleX:0.41,scaleY:0.41,skewX:0,skewY:180,x:496.3,y:138.2},0).wait(60).to({regY:6.7,scaleX:0.41,scaleY:0.42,skewX:2.3,skewY:181.5,x:496.5,y:138.1},0).wait(2).to({regX:8.8,regY:7,scaleY:0.42,skewX:4.5,skewY:183.3,x:496.6},0).wait(2).to({regX:8.7,scaleX:0.41,scaleY:0.42,skewX:6.8,skewY:184.8,x:496.8,y:137.9},0).wait(2).to({regX:8.6,regY:7.1,scaleY:0.42,skewX:9.3,skewY:186.6,x:497.1},0).wait(2).to({regX:8.7,skewY:186.5,x:497},0).wait(30).to({regX:8.6,skewY:186.6,x:497.1},0).wait(2).to({regY:7,scaleY:0.42,skewX:6.3,skewY:184.1,x:497},0).wait(2).to({scaleX:0.41,scaleY:0.42,skewX:3.3,skewY:181.8,x:496.7},0).wait(2).to({regX:8.7,regY:7.2,scaleY:0.42,skewX:0.5,skewY:179.7,x:496.5},0).wait(2).to({regX:8.6,regY:7.1,scaleY:0.41,skewX:-2.3,skewY:177.2,x:496.4,y:137.8},0).wait(2).to({regX:8.4,regY:4.5,scaleX:0.41,scaleY:0.41,skewX:-5.2,skewY:174.8,x:496.2},0).wait(2).to({regX:8.6,skewX:-3.3,skewY:176.7,y:137.9},0).wait(2).to({regX:8.5,skewX:-1.6,skewY:178.4,x:496.3,y:138.1},0).wait(2).to({regX:8.6,regY:7,skewX:0,skewY:180,y:138.2},0).wait(48).to({regX:8.1,regY:6.8,scaleX:0.46,scaleY:0.39,skewX:4.8,skewY:184.8,x:497.8,y:139.4},0).wait(2).to({regX:8.6,regY:7,scaleX:0.5,scaleY:0.37,skewX:9.8,skewY:189.8,x:498.7,y:140.6},0).wait(2).to({regX:8.8,regY:6.9,scaleX:0.54,scaleY:0.35,skewX:14.9,skewY:194.9,x:500,y:141.8},0).wait(4).to({regX:8.6,regY:7,scaleX:0.41,scaleY:0.41,skewX:0,skewY:180,x:496.3,y:138.2},0).wait(2).to({regX:8.4,scaleY:0.49,skewX:0.1,x:497,y:134.9},0).wait(2).to({regX:8.5,regY:7.1,scaleY:0.58,skewX:0.5,x:497.5,y:131.5},0).wait(6).to({regX:8.4,regY:7.2,scaleY:0.58,skewX:-1.8,x:496.6,y:131.6},0).wait(2).to({regX:8.5,regY:7.1,scaleY:0.58,skewX:-4.3,x:495.4,y:131.5},0).wait(2).to({regX:8.6,scaleY:0.58,skewX:-6.7,x:494.3},0).wait(2).to({regX:10.5,scaleY:0.58,skewX:-3,x:495.1},0).wait(2).to({regX:8.5,scaleY:0.58,skewX:0.5,x:497.5},0).wait(2).to({regX:8.4,regY:7.2,scaleY:0.58,skewX:-1.3,x:496.8,y:131.6},0).wait(2).to({regX:10.5,regY:7.1,scaleY:0.58,skewX:-3,x:495.1,y:131.5},0).wait(2).to({regX:8.5,scaleY:0.58,skewX:-4.8,y:131.6},0).wait(2).to({regX:8.6,scaleY:0.58,skewX:-6.7,x:494.3,y:131.5},0).wait(2).to({regX:8.5,scaleY:0.58,skewX:-4.3,x:495.4},0).wait(2).to({regX:8.4,regY:7.2,scaleY:0.58,skewX:-1.8,x:496.6,y:131.6},0).wait(2).to({regX:8.5,regY:7.1,scaleY:0.58,skewX:0.5,x:497.5,y:131.5},0).wait(2).to({regX:8.4,regY:7.2,scaleY:0.58,skewX:-1.8,x:496.6,y:131.6},0).wait(2).to({regX:8.5,regY:7.1,scaleY:0.58,skewX:-4.3,x:495.4,y:131.5},0).wait(2).to({regX:8.6,scaleY:0.58,skewX:-6.7,x:494.3},0).wait(2).to({regX:8.5,scaleY:0.58,skewX:-4.3,x:495.4},0).wait(2).to({regX:8.4,regY:7.2,scaleY:0.58,skewX:-1.8,x:496.6,y:131.6},0).wait(2).to({regX:8.5,regY:7.1,scaleY:0.58,skewX:0.5,x:497.5,y:131.5},0).wait(2).to({regX:8.4,scaleY:0.52,skewX:0.3,x:497.2,y:133.7},0).wait(2).to({regY:7.2,scaleY:0.47,skewX:0,x:496.7,y:136},0).wait(2).to({regX:8.6,regY:7,scaleY:0.41,x:496.3,y:138.2},0).wait(168));

	// Iguana Front Back Foot
	this.instance_14 = new lib.IguanaFrontBackFoot_1();
	this.instance_14.parent = this;
	this.instance_14.setTransform(496.7,153.6,0.412,0.412,0,0,180,5.6,3.8);

	this.timeline.addTween(cjs.Tween.get(this.instance_14).wait(192).to({scaleY:0.41},0).wait(2).to({scaleY:0.41},0).wait(46).to({scaleY:0.41},0).wait(168));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(471.2,113.2,119,54);


(lib.iguana = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// legGlow
	this.legGlow = new lib.iguana_legGlow();
	this.legGlow.parent = this;
	this.legGlow.setTransform(223.5,212.5,1,1,0,0,0,10.7,6);
	this.legGlow.alpha = 0;
	this.legGlow.filters = [new cjs.BlurFilter(3, 3, 1)];
	this.legGlow.cache(-33,-21,58,38);

	this.timeline.addTween(cjs.Tween.get(this.legGlow).wait(1));

	// neckGlow
	this.neckGlow = new lib.iguana_neckGlow();
	this.neckGlow.parent = this;
	this.neckGlow.setTransform(185.8,172.9,1,1,-5.3,0,0,10.7,14.6);
	this.neckGlow.alpha = 0;
	this.neckGlow.filters = [new cjs.BlurFilter(3, 3, 1)];
	this.neckGlow.cache(-3,-3,27,35);

	this.timeline.addTween(cjs.Tween.get(this.neckGlow).wait(1));

	// backGlow
	this.backGlow = new lib.iguana_backGlow();
	this.backGlow.parent = this;
	this.backGlow.setTransform(218.1,188.9,1,1,0,0,0,25.1,13.8);
	this.backGlow.alpha = 0;
	this.backGlow.filters = [new cjs.BlurFilter(3, 3, 1)];
	this.backGlow.cache(-3,-3,57,35);

	this.timeline.addTween(cjs.Tween.get(this.backGlow).wait(1));

	// tailGlow
	this.tailGlow = new lib.iguana_tailGlow();
	this.tailGlow.parent = this;
	this.tailGlow.setTransform(283.8,210.1,1,1.057,0,0,0,46.9,10.2);
	this.tailGlow.alpha = 0;
	this.tailGlow.filters = [new cjs.BlurFilter(3, 3, 1)];
	this.tailGlow.cache(-3,-3,101,27);

	this.timeline.addTween(cjs.Tween.get(this.tailGlow).wait(1));

	// Layer 27
	this.leg2 = new lib.invisiblebox();
	this.leg2.parent = this;
	this.leg2.setTransform(223.9,211.2,0.228,0.481,-84.3);

	this.leg1 = new lib.invisiblebox();
	this.leg1.parent = this;
	this.leg1.setTransform(187.8,199.8,0.294,0.508,0,-13.8,-1.5);

	this.back = new lib.invisiblebox();
	this.back.parent = this;
	this.back.setTransform(218.2,190.3,1.243,0.366,26.6);

	this.tail = new lib.invisiblebox();
	this.tail.parent = this;
	this.tail.setTransform(290.1,215.4,2.181,0.337,0,3.9,8.2);

	this.tummy = new lib.invisiblebox();
	this.tummy.parent = this;
	this.tummy.setTransform(203.8,206.3,0.202,0.285,117.8);

	this.neck = new lib.invisiblebox();
	this.neck.parent = this;
	this.neck.setTransform(186,172.2,0.327,0.39,23.3);

	this.mouth = new lib.invisiblebox();
	this.mouth.parent = this;
	this.mouth.setTransform(164.6,167.6,0.496,0.412,0,4.3,22.6);

	this.foot2 = new lib.invisiblebox();
	this.foot2.parent = this;
	this.foot2.setTransform(183,221.3,0.553,0.347,8.7);

	this.foot1 = new lib.invisiblebox();
	this.foot1.parent = this;
	this.foot1.setTransform(221.3,225.1,0.714,0.355,0,-4.5,0.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.foot1},{t:this.foot2},{t:this.mouth},{t:this.neck},{t:this.tummy},{t:this.tail},{t:this.back},{t:this.leg1},{t:this.leg2}]}).wait(1));

	// main
	this.main = new lib.Iguana();
	this.main.parent = this;
	this.main.setTransform(-546.4,64.7,1.54,1.54,0,0,0,20.5,55.3);

	this.timeline.addTween(cjs.Tween.get(this.main).wait(1));

}).prototype = getMCSymbolPrototype(lib.iguana, new cjs.Rectangle(147.7,153.7,190.7,83.3), null);


// stage content:
(lib.MWiguana = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":209});

	// Layer 5
	this.instance_2 = new lib.iguana_legMud_001_bubbles();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-40.1,4.6);
	this.instance_2._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(6).to({_off:false},0).wait(204));

	// Layer 3
	this.instance_3 = new lib.iguana_legGlow();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-20.8,-0.6,1.562,1.562,0,0,180,-3.9,-1.8);
	this.instance_3._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(4).to({_off:false},0).to({_off:true},2).wait(204));

	// Layer 4
	this.instance_4 = new lib.IguanaLowerarm0001();
	this.instance_4.parent = this;
	this.instance_4.setTransform(-1.9,-3.2,0.5,0.5);

	this.instance_5 = new lib.IguanaLowerarm0002();
	this.instance_5.parent = this;
	this.instance_5.setTransform(-1.9,-3.2,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_4}]}).to({state:[{t:this.instance_5}]},2).to({state:[{t:this.instance_4}]},2).to({state:[{t:this.instance_5}]},2).wait(204));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(298.1,150.3,22,32);
// library properties:
lib.properties = {
	width: 600,
	height: 307,
	fps: 30,
	color: "#FFFFFF",
	opacity: 1.00,
	manifest: [
		{src:"../../../deploy/assets/images/MWiguana_atlas_.png?1528310757014", id:"MWiguana_atlas_"}
	],
	preloads: []
};




})(lib_Iguana = lib_Iguana||{}, images = images||{}, createjs = createjs||{}, ss = ss||{}, AdobeAn = AdobeAn||{});
var lib_Iguana, images, createjs, ss, AdobeAn;